//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { BOKKZ_BASE_URL, BOKKZ_SERVICE_URL, Kolommenbalans } from './api.bokkz.services';

@Injectable({
    providedIn: 'root',
})
export class BokkzRapportageClient {
    private http: HttpClient;
    private baseUrl: string;
    private serviceUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient,
                @Optional() @Inject(BOKKZ_BASE_URL) baseUrl?: string,
                @Optional() @Inject(BOKKZ_SERVICE_URL) serviceUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
        this.serviceUrl = serviceUrl !== undefined && serviceUrl !== null ? serviceUrl : '';
    }

    /**
     * @return default response
     */
    getStatus(): Observable<void> {
        let url_ = this.baseUrl + '/api/v1/sst/status';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'application/json',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatus(response_);
                }),
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatus(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                }),
            );
    }

    getCalculation(body?: Jaarrekening | undefined, isEntityNaturalPerson?: boolean): Observable<Jaarrekening> {
        let url_ = this.serviceUrl + "/api/v1/jr/calculate";
        if (isEntityNaturalPerson !== undefined) {
            const queryString = new URLSearchParams({ isEntityNaturalPerson: isEntityNaturalPerson.toString() }).toString();
            url_ = url_ + '?' + queryString;
        }

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processgetCalculation(response_);
                }),
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processgetCalculation(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<Jaarrekening>;
                        }
                    } else return _observableThrow(response_) as any as Observable<Jaarrekening>;
                }),
            );
    }

    protected processgetCalculation(response: HttpResponseBase): Observable<Jaarrekening> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                  ? (response as any).error
                  : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let resultdefault: any = null;
                    resultdefault = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Jaarrekening);
                    return _observableOf(resultdefault);
                }),
            );
        }
    }

    protected processGetStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                  ? (response as any).error
                  : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return _observableOf(null as any);
                }),
            );
        }
    }

    postjaarrapportage(
        sstRelatieId: string,
        year: string,
        sendToAuthorities: boolean,
        entrypointId?: string,
        body?: JaarrapportageEntity | undefined,
    ): Observable<JaarrapportageEntity> {
        let url_ = this.baseUrl + '/api/v1/sst/jaarrapportage/{sstRelatieId}/{year}/{sendToAuthorities}/{entrypointId}';
        if (sstRelatieId === undefined || sstRelatieId === null) throw new Error("The parameter 'sstRelatieId' must be defined.");
        if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
        if (sendToAuthorities === undefined || sendToAuthorities === null)
            throw new Error("The parameter 'sendToAuthorities' must be defined.");
        url_ = url_.replace('{sstRelatieId}', encodeURIComponent('' + sstRelatieId));
        url_ = url_.replace('{year}', encodeURIComponent('' + year));
        url_ = url_.replace('{sendToAuthorities}', encodeURIComponent('' + sendToAuthorities));
        if (entrypointId) {
            url_ = url_.replace('{entrypointId}', encodeURIComponent('' + entrypointId));
        } else {
            url_ = url_.replace('{entrypointId}', encodeURIComponent('0'));
        }
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processPostjaarrapportage(response_);
                }),
            )
          .pipe(
            _observableCatch((response_: any) => {
              if (response_ instanceof HttpErrorResponse) {
                return _observableThrow(response_);
              }
              return _observableThrow(response_);
            })
          );
    }

    protected processPostjaarrapportage(response: HttpResponseBase): Observable<JaarrapportageEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                  ? (response as any).error
                  : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let resultdefault: any = null;
                    resultdefault =
                        _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as JaarrapportageEntity);
                    return _observableOf(resultdefault);
                }),
            );
        }
    }

    getValidation(body?: Jaarrapportage) {
        let url_ = this.serviceUrl + '/api/v1/jr/validate';
        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processgetValidation(response_);
                }),
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processgetValidation(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<any>;
                        }
                    } else return _observableThrow(response_) as any as Observable<any>;
                }),
            );
    }

    protected processgetValidation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                  ? (response as any).error
                  : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let resultdefault: any = null;
                    resultdefault = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
                    return _observableOf(resultdefault);
                }),
            );
        }
    }

    /**
     * @return default response
     */
    getSwagger(): Observable<void> {
        let url_ = this.baseUrl + '/api/v1/sst/openapi';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'application/json',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSwagger(response_);
                }),
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSwagger(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<void>;
                        }
                    } else return _observableThrow(response_) as any as Observable<void>;
                }),
            );
    }

    protected processGetSwagger(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                  ? (response as any).error
                  : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return _observableOf(null as any);
                }),
            );
        }
    }

    /**
     * @return default response
     */
    getjaarrapportage(clientId: string, year: string): Observable<JaarrapportageEntity> {
        let url_ = this.baseUrl + '/api/v1/sst/jaarrapportage/{clientId}/{year}';
        if (clientId === undefined || clientId === null) throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
        if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace('{year}', encodeURIComponent('' + year));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'application/json',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetjaarrapportage(response_);
                }),
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetjaarrapportage(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<JaarrapportageEntity>;
                        }
                    } else return _observableThrow(response_) as any as Observable<JaarrapportageEntity>;
                }),
            );
    }

    protected processGetjaarrapportage(response: HttpResponseBase): Observable<JaarrapportageEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                  ? (response as any).error
                  : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let resultdefault: any = null;
                    resultdefault =
                        _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as JaarrapportageEntity);
                    return _observableOf(resultdefault);
                }),
            );
        }
    }

  /**
   * @return default response
   */
  deleteJaarrapportage(clientId: string, year: string): Observable<JaarrapportageEntity> {
    let url_ = this.baseUrl + '/api/v1/sst/jaarrapportage/{clientId}/{year}';
    if (clientId === undefined || clientId === null) throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace('{clientId}', encodeURIComponent('' + clientId));
    if (year === undefined || year === null) throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace('{year}', encodeURIComponent('' + year));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteJaarrapportage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteJaarrapportage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<JaarrapportageEntity>;
            }
          } else return _observableThrow(response_) as any as Observable<JaarrapportageEntity>;
        }),
      );
  }

  protected processDeleteJaarrapportage(response: HttpResponseBase): Observable<JaarrapportageEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault =
            _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as JaarrapportageEntity);
          return _observableOf(resultdefault);
        }),
      );
    }
  }

    /**
     * @return default response
     */
    getExternalGrammar(path: string): Observable<FileResponse> {
        let url_ = this.baseUrl + '/application.wadl/{path}';
        if (path === undefined || path === null) throw new Error("The parameter 'path' must be defined.");
        url_ = url_.replace('{path}', encodeURIComponent('' + path));
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'application/json',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetExternalGrammar(response_);
                }),
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetExternalGrammar(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<FileResponse>;
                        }
                    } else return _observableThrow(response_) as any as Observable<FileResponse>;
                }),
            );
    }

    protected processGetExternalGrammar(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                  ? (response as any).error
                  : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        {
            const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
            let fileNameMatch = contentDisposition
                ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
                : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        }
    }

    /**
     * @return default response
     */
    getWadl(): Observable<FileResponse> {
        let url_ = this.baseUrl + '/application.wadl';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'application/json',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetWadl(response_);
                }),
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetWadl(response_ as any);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<FileResponse>;
                        }
                    } else return _observableThrow(response_) as any as Observable<FileResponse>;
                }),
            );
    }

    protected processGetWadl(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                  ? (response as any).error
                  : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        {
            const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
            let fileNameMatch = contentDisposition
                ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
                : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        }
    }
}

/** Aandeel in het groepsvermogen dat niet aan de rechtspersoon toekomt */
export interface AandeelDerden {
    noncontrollingInterest?: BalanceItem;
    aandeelDerdenTekstueel?: AandeelDerdenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting aandeel in het groepsvermogen dat niet aan de rechtspersoon toekomt */
export interface AandeelDerdenTekstueel {
    noncontrollingInterestDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Aandeel in resultaat van ondernemingen waarin wordt deelgenomen */
export interface AandeelResultaatOndernemingenWaarinWordtDeelgenomen {
    shareInResultsParticipatingInterests?: BalanceItem;
    aandeelResultaatOndernemingenWaarinWordtDeelgenomenTekstueel?: AandeelResultaatOndernemingenWaarinWordtDeelgenomenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting aandeel in resultaat van ondernemingen waarin wordt deelgenomen */
export interface AandeelResultaatOndernemingenWaarinWordtDeelgenomenTekstueel {
    shareInResultsParticipatingInterestsDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Aandeel in winst partners */
export interface AandeelWinstPartners {
    shareInResultsPartners?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Gestort en opgevraagd aandelenkapitaal */
export interface Aandelenkapitaal {
    shareCapitalPaidCalledUp?: BalanceItem;
    aandelenkapitaalTekstueel?: AandelenkapitaalTekstueel;
    aandelenkapitaalOverigeBedragenUitsplitsing?: AandelenkapitaalOverigeBedragenUitsplitsing;

    [key: string]: any;
}

/** Uitsplitsing aandelenkapitaal overige bedragen */
export interface AandelenkapitaalOverigeBedragenUitsplitsing {
    shareCapitalIssued?: MonetaryNoDecimalsPeriodValues;
    shareCapitalPaid?: MonetaryNoDecimalsPeriodValues;
    shareCapitalRegistered?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Tekstuele toelichting aandelenkapitaal */
export interface AandelenkapitaalTekstueel {
    shareCapitalPaidCalledUpDisclosure?: FormattedExplanation;
    treasurySharesDisclosure?: FormattedExplanation;
    shareCapitalTreasurySharesPurchaseSaleDescription?: FormattedExplanation;
    shareCapitalInTheCurrencyOfDenominationWhenDifferentPresentationCurrencyDisclosure?: FormattedExplanation;
    shareCapitalContributionInKindDescription?: FormattedExplanation;
    shareCapitalTreasurySharesHeldDescription?: FormattedExplanation;
    shareCapitalTreasurySharesPledgedDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Totaal van activa */
export interface ActivaJaarstukken {
    assets?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Adres van de entiteit */
export interface AdresEntiteit {
    streetNameNL?: String80;
    houseNumberNL?: NonNegativeInteger;
    houseNumberAddition?: String4;
    poBoxNumber?: NonNegativeInteger;
    postalCodeNL?: NlZip;
    placeOfResidenceNL?: String80;
    descriptionLocationAbroad?: String1000;
    streetNameAbroad?: String1000;
    houseNumberAbroad?: String1000;
    postalCodeAbroad?: String1000;
    placeOfResidenceAbroad?: String1000;
    nameRegion?: String1000;
    countryName?: String1000;
    descriptionLocationNL?: String1000;

    [key: string]: any;
}

/** Afschrijvingen op immateriële en materiële vaste activa */
export interface AfschrijvingenIvaMva {
    depreciationPropertyPlantEquipmentAmortisationIntangibleAssets?: MonetaryNoDecimalsPeriodValues;
    afschrijvingenIvaMvaUitsplitsing?: AfschrijvingenIvaMvaUitsplitsing;
    afschrijvingenIvaMvaTekstueel?: AfschrijvingenIvaMvaTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting afschrijvingen op immateriële en materiële vaste activa */
export interface AfschrijvingenIvaMvaTekstueel {
    depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsDisclosure?: FormattedExplanation;
    amortisationIntangibleAssetsDisclosure?: FormattedExplanation;
    depreciationPropertyPlantEquipmentDisclosure?: FormattedExplanation;
    arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie afschrijvingen op immateriële en materiële vaste activa */
export interface AfschrijvingenIvaMvaUitsplitsing {
    amortisationIntangibleAssets?: BalanceItem;
    depreciationPropertyPlantEquipment?: BalanceItem;
    resultSaleIntangibleAssets?: BalanceItem;
    resultSalePropertyPlantEquipment?: BalanceItem;

    [key: string]: any;
}

/** Agio */
export interface Agio {
    sharePremium?: BalanceItem;
    agioTekstueel?: AgioTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting agio */
export interface AgioTekstueel {
    sharePremiumDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Algemene grondslagen voor verslaggeving */
export interface AlgemeneGrondslagen {
    algemeen?: AlgemeneGrondslagenAlgemeen;
    schattingswijzigingen?: Schattingswijzigingen;
    stelselwijzigingen?: Stelselwijzigingen;
    foutherstel?: Foutherstel;
    omrekeningVreemdeValuta?: OmrekeningVreemdeValuta;
    leases?: Leases;
    opAandelenGebaseerdeBetalingen?: OpAandelenGebaseerdeBetalingenAlgemeneGrondslagen;
    bijzonderePosten?: BijzonderePostenAlgemeneGrondslagen;
    pensioenregelingen?: Pensioenregelingen;
    financieleInstrumenten?: FinancieleInstrumentenAlgemeneGrondslagen;

    [key: string]: any;
}

/** Algemene grondslagen */
export interface AlgemeneGrondslagenAlgemeen {
    algemeneGrondslagenAlgemeenTekstueel?: AlgemeneGrondslagenAlgemeenTekstueel;

    [key: string]: any;
}

/** Grondslagen algemeen */
export interface AlgemeneGrondslagenAlgemeenTekstueel {
    accountingStandardsUsedToPrepareFinancialStatementsDescription?: FormattedExplanationPolicy;
    accountingStandardsAppliedEarlierDescription?: FormattedExplanationPolicy;
    noChangesInAccountingPoliciesDescription?: FormattedExplanationPolicy;
    fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosure?: FormattedExplanationPolicy;
    historicalCostInformationWhenPreparedOnFairValueBasisDisclosure?: FormattedExplanationPolicy;
    differenceFiscalCommercialAccountingPrinciplesDisclosure?: FormattedExplanationPolicy;
    determinationCostPriceIndirectCostsDescription?: FormattedExplanationPolicy;
    functionalCurrencyDescription?: FormattedExplanationPolicy;
    foreignCurrencyTranslationDifferencePresentationFunctionalCurrencyDescription?: FormattedExplanationPolicy;
    foreignCurrencyTranslationChangePresentationCurrencyDescription?: FormattedExplanationPolicy;
    foreignCurrencyTranslationDifferencePresentationLocalCurrencyDescription?: FormattedExplanationPolicy;
    foreignCurrencyTranslationChangeFunctionalCurrencyDescription?: FormattedExplanationPolicy;
    foreignCurrencyTranslationFunctionalCurrencyHyperinflationDescription?: FormattedExplanationPolicy;
    relatedPartyTransactionsPolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Algemene toelichting */
export interface AlgemeneToelichting {
    algemeen?: AlgemeneToelichtingAlgemeen;
    continuiteit?: Continuiteit;
    groepsverhoudingen?: Groepsverhoudingen;
    schattingen?: Schattingen;
    consolidatie?: Consolidatie;
    fusiesOvernames?: FusiesOvernames;
    beeindigingBedrijfsactiviteiten?: BeeindigingBedrijfsactiviteiten;

    [key: string]: any;
}

/** Algemene toelichtingen */
export interface AlgemeneToelichtingAlgemeen {
    algemeneToelichtingAlgemeenTekstueel?: AlgemeneToelichtingAlgemeenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting algemeen */
export interface AlgemeneToelichtingAlgemeenTekstueel {
    mostImportantActivitiesEntityDescription?: FormattedExplanation;
    locationActualActivitiesDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Andere wettelijke reserves */
export interface AndereWettelijkeReserves {
    legalReserves?: MonetaryNoDecimalsPeriodValues;
    andereWettelijkeReservesUitsplitsing?: AndereWettelijkeReservesUitsplitsing;
    andereWettelijkeReservesTekstueel?: AndereWettelijkeReservesTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting andere wettelijke reserves */
export interface AndereWettelijkeReservesTekstueel {
    legalReservesDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie andere wettelijke reserves */
export interface AndereWettelijkeReservesUitsplitsing {
    legalReserveNegativeTranslationShareCapitalIntoEuros?: BalanceItem;
    legalReserveTranslationShareCapitalIntoEuros?: BalanceItem;
    legalReserveContributionInKind?: BalanceItem;
    legalReserveLoansProvidedObtainTreasuryShares?: BalanceItem;
    legalReserveCostsIncorporationShareIssue?: BalanceItem;
    legalReserveDevelopment?: BalanceItem;
    legalReserveParticipatingInterests?: BalanceItem;
    reserveTranslationDifferencesConversionInvestedAssetsResultParticipatingInterests?: BalanceItem;
    foreignCurrencyTranslationReserve?: BalanceItem;

    [key: string]: any;
}

/** Aandeel in het geconsolideerde resultaat dat niet aan de rechtspersoon toekomt */
export interface BalanceItem {
    /** Value current period */
    valuePeriod1?: number;
    /** Value previous period */
    valuePeriod2?: number;
    trialBalanceItems?: TrialBalanceItem[];

    [key: string]: any;
}

/** Balans */
export interface Balans {
    balanceSheetBeforeAfterAppropriationResults: ProfitAppropriation;
    immaterieleVasteActiva?: ImmaterieleVasteActiva;
    materieleVasteActiva?: MaterieleVasteActiva;
    vastgoedbeleggingen?: Vastgoedbeleggingen;
    financieleVasteActiva?: FinancieleVasteActiva;
    vasteActiva?: VasteActiva;
    voorraden?: Voorraden;
    onderhandenProjecten?: OnderhandenProjecten;
    vorderingen?: Vorderingen;
    effecten?: EffectenJaarstukken;
    liquideMiddelen?: LiquideMiddelen;
    vlottendeActiva?: VlottendeActiva;
    activa?: ActivaJaarstukken;
    aandelenkapitaal?: Aandelenkapitaal;
    agio?: Agio;
    herwaarderingsreserve?: Herwaarderingsreserve;
    andereWettelijkeReserves?: AndereWettelijkeReserves;
    statutaireReserves?: StatutaireReserves;
    financieleInstrumentenEigenVermogen?: FinancieleInstrumentenEigenVermogen;
    herinvesteringsreserve?: HerinvesteringsreserveJaarstukken;
    overigeReserves?: OverigeReserves;
    overigeFiscaleReserves?: OverigeFiscaleReserves;
    voorgesteldeBedragDividenduitkeringen?: VoorgesteldeBedragDividenduitkeringen;
    resultaatBoekjaar?: ResultaatBoekjaar;
    uitTeKerenPreferentDividend?: UitTeKerenPreferentDividend;
    nietVerdeeldeWinsten?: NietVerdeeldeWinsten;
    eigenVermogenNatuurlijkePersonen?: EigenVermogenNatuurlijkePersonen;
    eigenVermogen?: EigenVermogen;
    aandeelDerden?: AandeelDerden;
    groepsvermogen?: Groepsvermogen;
    voorzieningen?: Voorzieningen;
    langlopendeSchulden?: LanglopendeSchulden;
    kortlopendeSchulden?: KortlopendeSchulden;
    schulden?: Schulden;
    passiva?: PassivaJaarstukken;

    [key: string]: any;
}

/** Type grondslag */
export interface BasisOfPreparation {
    value?: BasisOfPreparationValue;

    [key: string]: any;
}

/** Totaal van bedrijfslasten */
export interface Bedrijfslasten {
    operatingExpenses?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Totaal van bedrijfsopbrengsten */
export interface Bedrijfsopbrengsten {
    operatingIncome?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Bedrijfsresultaat */
export interface Bedrijfsresultaat {
    operatingResult?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Bedrijfsactiviteiten die niet duurzaam worden voortgezet */
export interface BeeindigingBedrijfsactiviteiten {
    beeindigingBedrijfsactiviteitenTekstueel?: BeeindigingBedrijfsactiviteitenTekstueel;
    /** Specificatie van bedrijfsactiviteiten die niet duurzaam worden voortgezet */
    beeindigingBedrijfsactiviteitenSpecificatie?: BeeindigingBedrijfsactiviteitenBeeindigingBedrijfsactiviteit[];

    [key: string]: any;
}

/** Specificatie van bedrijfsactiviteiten die niet duurzaam worden voortgezet */
export interface BeeindigingBedrijfsactiviteitenBeeindigingBedrijfsactiviteit {
    discontinuedOperationsTypedMember: String255;
    discontinuedOperationsDescription?: FormattedExplanation;
    discontinuedOperationsConsequencesOfChangesInPlanDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Tekstuele toelichting bedrijfsactiviteiten die niet duurzaam worden voortgezet */
export interface BeeindigingBedrijfsactiviteitenTekstueel {
    discontinuedOperationsDisclosure?: FormattedExplanation;
    resultBeforeTaxDueToSaleOfAssetsIncludingImpactOfDiscontinuedOperationsDescription?: FormattedExplanation;
    discontinuedOperationsNatureOfInitialEventDescription?: FormattedExplanation;
    discontinuedOperationsTimeOfInitialEventDescription?: FormattedExplanation;
    discontinuedOperationsFinalisationTimeDescription?: FormattedExplanation;
    expectedTimingReceiptNetResultDiscontinuedOperationsAssetsDescription?: FormattedExplanation;
    expectedTimingReceiptNetResultDiscontinuedOperationsLongTermLoansDescription?: FormattedExplanation;
    resultBeforeTaxDueSettlementOfEquityIncludingImpactOfDiscontinuedOperationsDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Belastingen over de winst of het verlies */
export interface Belastingen {
    incomeTaxExpense?: MonetaryNoDecimalsPeriodValues;
    belastingenUitsplitsing?: BelastingenUitsplitsing;
    belastingenTekstueel?: BelastingenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting belastingen */
export interface BelastingenTekstueel {
    incomeTaxExpenseDisclosure?: FormattedExplanation;
    incomeTaxExpenseOrdinaryActivitiesDisclosure?: FormattedExplanation;
    incomeTaxExpenseReconciliationToCorporateTaxReturnDisclosure?: FormattedExplanation;
    incomeTaxFiscalAdjustmentsPriorYearsDisclosure?: FormattedExplanation;
    pillarTwoDeferredTaxAssetsLiabilitiesDescription?: FormattedExplanation;
    pillarTwoTaxExpenseBenefitDescription?: FormattedExplanation;
    pillarTwoMethodDescription?: FormattedExplanation;
    pillarTwoExpectedEffectsDescription?: FormattedExplanation;
    incomeTaxExpenseRateDescription?: FormattedExplanation;
    mainDifferencesEffectiveTaxRatePreviousYearDescription?: FormattedExplanation;
    discountRateOfPresentValueDeferredTaxLiabilitiesAndAssetsAppliedPercentageNetInterestDescription?: FormattedExplanation;
    averageTermLiabilitiesAndAssetsDescription?: FormattedExplanation;
    statisticalConnectionTaxChargeOrGainResultBeforeTaxAndAppliedTaxRateDescription?: FormattedExplanation;
    methodCalculationAppliedTaxRateDescription?: FormattedExplanation;
    statisticalConnectionAverageEffectiveTaxRateAndAppliedTaxRateDescription?: FormattedExplanation;
    methodCalculationEffectiveTaxRateDescription?: FormattedExplanation;
    incomeTaxExpenseOtherDisclosure?: FormattedExplanation;
    incomeTaxFiscalUnityDisclosure?: FormattedExplanation;
    incomeTaxForwardLossCompensationTemporaryDifferencesDescription?: FormattedExplanation;
    incomeTaxForwardLossCompensationDescription?: FormattedExplanation;
    expiryDatesIncomeTaxForwardLossCompensationDescription?: FormattedExplanation;
    presentationOfDefferedTaxAssetsDeductibleWithinTwelveMonthsDescription?: FormattedExplanation;
    incomeTaxTemporaryDifferencesDescription?: FormattedExplanation;
    incomeTaxProfitRetentionFiscalRatesReasonInfeasibleExplanation?: FormattedExplanation;
    incomeTaxRecordedDirectlyIntoEquityDisclosure?: FormattedExplanation;
    deferredTaxDiscountedValueDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie belastingen */
export interface BelastingenUitsplitsing {
    deferredIncomeTaxExpense?: BalanceItem;
    incomeTaxExpensePrevious?: BalanceItem;
    incomeTaxExpenseCurrent?: BalanceItem;
    decreaseInValueDeferredTaxAssets?: BalanceItem;
    incomeTaxExpenseOther?: BalanceItem;

    [key: string]: any;
}

/** Bestuurders en commissarissen */
export interface BestuurderCommissaris {
    managingOrSupervisoryDirectorOrRepresentativeName: String255;
    ondertekeningJaarrekening?: OndertekeningJaarrekening;

    [key: string]: any;
}

/** Bestuursverslag */
export interface Bestuursverslag {
    generalInformationManagementReport?: FormattedExplanation;
    descriptionOfTheObjective?: FormattedExplanation;
    coreBusinessDescription?: FormattedExplanation;
    descriptionOfTheLegalStructure?: FormattedExplanation;
    internalOrganisationalStructureAndStaffingDescription?: FormattedExplanation;
    keyElementsOfPoliciesConductedDescription?: FormattedExplanation;
    financialInformation?: FormattedExplanation;
    analysisOfTheSituationOnTheBalanceSheetDate?: FormattedExplanation;
    analysisOfTheDevelopmentsThroughoutTheFinancialYear?: FormattedExplanation;
    analysisOfTheAchievedResults?: FormattedExplanation;
    analysisOfCashflowsAndFinancingNeedsDisclosure?: FormattedExplanation;
    analysisOfMainRisksAndUncertaintiesDisclosure?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToTechnologicalDevelopments?: FormattedExplanation;
    descriptionOfTheOperationalRisksAndUncertaintiesRelatingToInternalOrganizationAndAdministration?: FormattedExplanation;
    descriptionOfTheOperationalRisksAndUncertaintiesRelatingToPersonnelProductsAndTheEnvironment?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatedToTheDependenceOfTheEntityOnProductsAndServices?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToChangesInStrategy?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToFinancialReporting?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatedToSustainability?: FormattedExplanation;
    descriptionOfTheOperationalRisksAndUncertaintiesRelatedToTheReputationOfTheEntity?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToDevelopmentsInTheCompetitiveAbilityOfTheEntity?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToTheFinancialPositionOfTheEntity?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatedToSocialDevelopments?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToInternalAndExternalLawsAndRegulations?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesMarketDemandsOnProductAndServicesOfTheEntity?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToTheStrategyOfTheEntity?: FormattedExplanation;
    descriptionOfTheOperationalRisksAndUncertaintiesRelatedToTheRemunerationPolicy?: FormattedExplanation;
    descriptionOfTheOperationalRisksAndUncertaintiesRelatingToCorruption?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatedToGovernance?: FormattedExplanation;
    descriptionOfTheOperationalRisksAndUncertaintiesRelatingToVulnerabilityToFraud?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToOperatingActivities?: FormattedExplanation;
    descriptionOfThePrincipalRisksAndUncertaintiesRelatingToTheImplementationOfNewInformationSystems?: FormattedExplanation;
    descriptionMainStrategicOperationalComplianceReportingRisks?: FormattedExplanation;
    descriptionResultsMaterialChangesExternalCircumstances?: FormattedExplanation;
    descriptionMaterialRisksUncertaintiesRelevantForContinuity?: FormattedExplanation;
    descriptionValuesMethodEmbedded?: FormattedExplanation;
    descriptionOperationComplianceBoardPreparedCodeOfConduct?: FormattedExplanation;
    descriptionOfUncertaintiesRelatingToComplexAllocationSystems?: FormattedExplanation;
    descriptionOfTheDegreeOfSubjectivityInValuations?: FormattedExplanation;
    descriptionOfTheRisksRelatingToImplementingFinancialReportingSystems?: FormattedExplanation;
    descriptionOfTheControlsToMitigateThePrincipalRisksAndUncertainties?: FormattedExplanation;
    descriptionOfTheExpectedImpactOnTheResultsAndFinancialPosition?: FormattedExplanation;
    descriptionOfSignificantRisksAndUncertaintiesOfThePastYearAndTheirConsequences?: FormattedExplanation;
    improvementInTheRiskManagementSystemWithRegardsToRisksAndUncertaintiesDescription?: FormattedExplanation;
    incorperationOfTheRiskManagementSystemDescription?: FormattedExplanation;
    measuresForInfluencingCultureBehaviourMotivationEmployeesDescription?: FormattedExplanation;
    willingnessOfHedgingRisksAndUncertaintiesDescription?: FormattedExplanation;
    descriptionOfTheSustainableSupplyChainManagement?: FormattedExplanation;
    descriptionOfRelevantSocialAspects?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspects?: FormattedExplanation;
    descriptionSocialAspectsUnderstandingTheChain?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsGovernanceEthicsOperations?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsInfluenceStakeholdersOperations?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsMainProblemsChallengesImpactOnStrategyOperations?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsRelationToOtherAspectsOperations?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEnvironmentalAspectsOperations?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEnvironmentalAspectsEnvironmentalProtectionMeasuresOperations?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheSocialAspectsOperations?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheSocialAspectsHumanRightsOperations?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheSocialAspectsSafetyHealthEducationDiversityOperations?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEconomicAspectsOperations?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEconomicAspectsFinancialContributionsToSocietyOperations?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEconomicAspectsNonFinancialContributionsToSocietyOperations?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsChain?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsGovernanceEthicsChain?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsInfluenceStakeholdersChain?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsMainProblemsChallengesImpactOnStrategyChain?: FormattedExplanation;
    descriptionOfTheCompanyActivitiesWithRegardsToTheGeneralSocialAspectsRelationToOtherAspectsChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEnvironmentalAspectsChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEnvironmentalAspectsEnvironmentalProtectionMeasuresChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheSocialAspectsChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheSocialAspectsHumanRightsChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheSocialAspectsSafetyHealthEducationDiversityChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEconomicAspectsChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEconomicAspectsFinancialContributionsToSocietyChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEconomicAspectsNonFinancialContributionsToSocietyChain?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEnvironmentalAspects?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheSocialAspects?: FormattedExplanation;
    descriptionOfTheBusinessActivitiesWithRegardsToTheEconomicAspects?: FormattedExplanation;
    descriptionOfTheSocialAspectsSpecificallyRelatedToTheChainInWhichTheEntityOperates?: FormattedExplanation;
    descriptionOfTheConsultationsAndOutcomesRelatedToTheDialogueWithStakeholders?: FormattedExplanation;
    descriptionOfTheConsultationWithStakeholders?: FormattedExplanation;
    descriptionOfTheOutcomesRelatedToTheDialogueWithStakeholders?: FormattedExplanation;
    descriptionOfThePoliciesWithRegardsToTheGeneralEnvironmentalSocialFinancialAndEconomicalAspects?: FormattedExplanation;
    descriptionOfThePoliciesWithRegardsToTheAspect?: FormattedExplanation;
    descriptionOfTheConsiderationsWithRegardsToTheAspect?: FormattedExplanation;
    descriptionOfTheGovernanceStructureAndManagementInformationSystemsForTheGeneralEnvironmentalSocialFinancialAndEconomicalAspects?: FormattedExplanation;
    descriptionOfTheDivisionOfTasksAndResponsibilitiesLegalEntity?: FormattedExplanation;
    descriptionOfMeasuresAndPerformanceByIndicators?: FormattedExplanation;
    descriptionOfTheReviewImplementationAndOutcomes?: FormattedExplanation;
    descriptionOfTheFutureExpectationsConcerningTheGeneralEnvironmentalSocialFinancialAndEconomicalAspects?: FormattedExplanation;
    descriptionOfInternalDevelopmentsImpactingSocialAspects?: FormattedExplanation;
    descriptionOfExternalDevelopmentsImpactingSocialAspects?: FormattedExplanation;
    subsequentEventsManagementReport?: FormattedExplanation;
    risksAndUncertaintiesInformation?: FormattedExplanation;
    financialInstrumentsInformation?: FormattedExplanation;
    financialInstrumentsRiskManagementObjectives?: FormattedExplanation;
    financialInstrumentsRiskManagementPolicy?: FormattedExplanation;
    financialInstrumentsRiskHedgingPolicy?: FormattedExplanation;
    corporateSocialResponsibilityInformation?: FormattedExplanation;
    codeOfConductInformation?: FormattedExplanation;
    communicationOnRemunerationPolicyManagement?: FormattedExplanation;
    referencesToAndAdditionalInformationAboutFinancialStatementsLineitems?: FormattedExplanation;
    descriptionOfDevelopmentsInMattersExpectationsStatedPreviousManagementReport?: FormattedExplanation;
    communicationOnExpectedBusinessDevelopments?: FormattedExplanation;
    communicationOnHowExceptionalEventsNotTakenIntoAccountAffectedTheExpectations?: FormattedExplanation;
    communicationOnExpectedBusinessDevelopmentsInvestments?: FormattedExplanation;
    communicationOnResearchAndDevelopmentActivities?: FormattedExplanation;
    communicationOnExpectedBusinessDevelopmentsStaffing?: FormattedExplanation;
    communicationOnExpectedBusinessDevelopmentsCircumstancesDevelopmentsRevenueProfitability?: FormattedExplanation;
    communicationOnExpectedBusinessDevelopmentsFinancing?: FormattedExplanation;
    otherInformationRelatingToMarketingAndDistribution?: FormattedExplanation;
    otherInformationRelatingToInternalControlWithRegardsToProcessesAndProcedures?: FormattedExplanation;
    otherInformationRegardingQualityControl?: FormattedExplanation;
    otherInformationRelatingToInternalAndExternalInformationSupply?: FormattedExplanation;
    otherInformationRelatingToAutomation?: FormattedExplanation;
    otherInformationConcerningRiskManagement?: FormattedExplanation;
    communicationOnTheMainFeaturesOfTheManagementAndControlSystemOfTheCompanyRelatingToTheFinancialReportingProcess?: FormattedExplanation;
    informationOtherManagementReport?: FormattedExplanation;
    activitiesEcologicalSustainabilityDescription?: FormattedExplanation;
    criticalPerformanceIndicatorPartSustainableActivitiesRevenueDescription?: FormattedExplanation;
    criticalPerformanceIndicatorPartSustainableActivitiesCapitalExpensesDescription?: FormattedExplanation;
    criticalPerformanceIndicatorPartSustainableActivitiesOperationalExpensesDescription?: FormattedExplanation;
    methodDeterminationEconomicActvitiesDescription?: FormattedExplanation;
    financialProductsSustainabilityDescription?: FormattedExplanation;
    managementReportLocationReference?: FormattedExplanation;

    [key: string]: any;
}

/** Bezoldiging van bestuurders en commissarissen: specificatie */
export interface BezoldigingBestuurderCommissaris {
    managingOrSupervisoryDirectorOrRepresentativeName: String255;
    regularRemunerationManagingSupervisoryDirector?: MonetaryNoDecimalsPeriodValues;
    longTermBenefitsDirector?: MonetaryNoDecimalsPeriodValues;
    benefitsOnTerminationOfServiceManagingSupervisoryDirector?: MonetaryNoDecimalsPeriodValues;
    profitSharingAndBonusPaymentsManagingSupervisoryDirector?: MonetaryNoDecimalsPeriodValues;
    remunerationManagingDirectorsAdjustment?: MonetaryNoDecimalsPeriodValues;
    remunerationManagingSupervisoryDirector?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Bezoldiging van bestuurders en commissarissen */
export interface BezoldigingBestuurdersCommissarissen {
    /** Bezoldiging van bestuurders en commissarissen: specificatie */
    bezoldigingBestuurdersCommissarissenSpecificatie?: BezoldigingBestuurderCommissaris[];
    bezoldigingBestuurdersCommissarissenTekstueel?: BezoldigingBestuurdersCommissarissenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting bezoldiging van bestuurders en commissarissen */
export interface BezoldigingBestuurdersCommissarissenTekstueel {
    remunerationManagingSupervisoryDirectorsDisclosure?: FormattedExplanation;
    remunerationManagingSupervisoryDirectorsExemptionDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Bijzondere posten */
export interface BijzonderePosten {
    bijzonderePostenTekstueel?: BijzonderePostenTekstueel;
    /** Specificatie van bijzondere posten */
    bijzonderePostenSpecificatie?: BijzonderePostenBijzonderePost[];

    [key: string]: any;
}

/** Bijzondere posten */
export interface BijzonderePostenAlgemeneGrondslagen {
    bijzonderePostenAlgemeneGrondslagenTekstueel?: BijzonderePostenAlgemeneGrondslagenTekstueel;

    [key: string]: any;
}

/** Grondslagen bijzondere posten */
export interface BijzonderePostenAlgemeneGrondslagenTekstueel {
    exceptionalItemsPolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Specificatie van bijzondere posten */
export interface BijzonderePostenBijzonderePost {
    exceptionalItemDescriptionTypedMember: String255;
    exceptionalItemAmount?: MonetaryNoDecimalsPeriodValues;
    exceptionalItemLineItemIncomeStatement?: String1000;
    financialImpactExceptionalItemIncorporatedOtherItemProfitLossDescription?: FormattedExplanation;
    exceptionalItemProcessedDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Tekstuele toelichting bijzondere posten */
export interface BijzonderePostenTekstueel {
    exceptionalItemsDisclosure?: FormattedExplanation;
    amountAndNatureOfItemsWithExceptionalExtentOrOccurrenceDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Bruto-bedrijfsresultaat */
export interface BrutoBedrijfsresultaat {
    grossMargin?: MonetaryNoDecimalsPeriodValues;
    brutoBedrijfsresultaatTekstueel?: BrutoBedrijfsresultaatTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting bruto-bedrijfsresultaat */
export interface BrutoBedrijfsresultaatTekstueel {
    grossMarginDisclosure?: FormattedExplanation;
    netRevenueRatioMovementComparedToPriorPeriodDisclosure?: FormattedExplanation;
    transitionalProvisionRevenueDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Type kasstroomoverzicht */
export interface CashFlowStatementMethod {
    value?: CashFlowStatementMethodValue;

    [key: string]: any;
}

/** Registratienummer bij de Kamer van Koophandel */
export interface ChamberOfCommerceRegistrationNumber {
    value?: string;

    [key: string]: any;
}

/** Concessies */
export interface Concessies {
    concessiesTekstueel?: ConcessiesTekstueel;
    /** Specificatie van concessies */
    concessiesSpecificatie?: ConcessiesConcessie[];

    [key: string]: any;
}

/** Specificatie van concessies */
export interface ConcessiesConcessie {
    licensingAgreementsTypedMember: String255;
    licensingAgreementsDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Tekstuele toelichting concessies */
export interface ConcessiesTekstueel {
    publicPrivateConcessionAgreementsPolicy?: FormattedExplanation;
    licensingAgreementsDisclosure?: FormattedExplanation;
    licensingAgreementsOutlineDescription?: FormattedExplanation;
    licensingAgreementsKeyTermsDescription?: FormattedExplanation;
    licensingAgreementsNatureAndExtentOfRightsofUseSpecificAssetsDescription?: FormattedExplanation;
    licensingAgreementsNatureAndExtentOfServiceObligationsRightsDescription?: FormattedExplanation;
    licensingAgreementsNatureAndExtentPropertyPlantEquipmentObligationsDescription?: FormattedExplanation;
    licensingAgreementsNatureAndExtentAssetTransferObligationsDescription?: FormattedExplanation;
    licensingAgreementsNatureAndExtentExtensionTerminationOptionsDescription?: FormattedExplanation;
    licensingAgreementsNatureAndExtentOtherRightsObligationsDescription?: FormattedExplanation;
    licensingAgreementsChangesDuringPeriodConcessionAgreementClassificationDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Consolidatie */
export interface Consolidatie {
    consolidatieTekstueel?: ConsolidatieTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting consolidatie */
export interface ConsolidatieTekstueel {
    consolidationDisclosure?: FormattedExplanation;
    consolidationExemptionDescription?: FormattedExplanation;
    consolidationPoliciesDescription?: FormattedExplanation;
    consolidationChangesInConsolidatedInterestsDescription?: FormattedExplanation;
    consolidationFirstConsolidationValuationDifferenceAndCalculationMethodDescription?: FormattedExplanation;
    consolidationProportionalDisclosure?: FormattedExplanation;
    reasonForNotConsolidatingCertainLegalEntitiesDescription?: FormattedExplanation;
    participationInvestmentFirmNonConsolidatedMajorityAndMinorityInterestDescription?: FormattedExplanation;
    foreignLegalEntityCoGroupParentDescription?: FormattedExplanation;
    consolidationNotEliminatingOfProfitAndLossesFromAgreementsBetweenConsolidatedEntitiesDisclosure?: FormattedExplanation;
    notificationApplicationArticle402Description?: FormattedExplanation;
    notificationOfLiabilityClaimInAccordanceWithArticle403?: FormattedExplanation;

    [key: string]: any;
}

/** Continuïteit */
export interface Continuiteit {
    continuiteitTekstueel?: ContinuiteitTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting continuïteit */
export interface ContinuiteitTekstueel {
    goingConcernDisclosure?: FormattedExplanation;
    goingConcernUncertaintiesEntitysAbilityToContinueAsGoingConcernDescription?: FormattedExplanation;
    goingConcernBasisForPreparationFinancialStatementsWhenNotGoingConcernBasisDescription?: FormattedExplanation;
    goingConcernEffectNotGoingConcernBasisOnEquityAndResultsDescription?: FormattedExplanation;
    goingConcernLiquidationPlanDescription?: FormattedExplanation;
    goingConcernNatureAmountSignificantPositiveNegativeChangesInValueDescription?: FormattedExplanation;
    goingConcernTheNatureAndAmountOfIncomeAndExpensesRecordedOnTheBalanceSheetUntilTheExpectedDateOfSettlementDescription?: FormattedExplanation;
    goingConcernMethodsAndSignificantAssumptionsUsedForValuationOnLiquidationBasisAndRelatedSignificantUncertaintiesDescription?: FormattedExplanation;
    goingConcernFactsAndCircumstancesNotGoingConcernDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Geboortedatum */
export interface CustomDate {
    value?: Date;

    [key: string]: any;
}

/** Soort bestuurder of commissaris */
export interface Director {
  value?: DirectorValue;

  [key: string]: any;
}

/** Soort verantwoordelijke of gemachtigde */
export interface RepresentativeType {
  value?: RepresentativeTypeValue;

  [key: string]: any;
}

/** Effecten */
export interface EffectenJaarstukken {
    securitiesCurrent?: MonetaryNoDecimalsPeriodValues;
    effectenUitsplitsing?: EffectenUitsplitsing;
    effectenTekstueel?: EffectenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting effecten */
export interface EffectenTekstueel {
    securitiesCurrentDisclosure?: FormattedExplanation;
    securitiesCurrentFairValueDisclosure?: FormattedExplanation;
    securitiesUnavailableCurrentDescription?: FormattedExplanation;
    securitiesNoLegalOwnershipDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing effecten */
export interface EffectenUitsplitsing {
    securitiesListed?: BalanceItem;
    securitiesNonListed?: BalanceItem;

    [key: string]: any;
}

/** Eigen vermogen */
export interface EigenVermogen {
    equity?: MonetaryNoDecimalsPeriodValues;
    eigenVermogenTekstueel?: EigenVermogenTekstueel;

    [key: string]: any;
}

/** Eigen vermogen natuurlijke personen: specificatie */
export interface EigenVermogenNatuurlijkPersoon {
    identificationNumberTypedMember: String255;
    eigenVermogenNatuurlijkPersoonMutatieoverzicht: EigenVermogenNatuurlijkPersoonMutatieoverzicht;
    /** Eigen vermogen natuurlijk persoon - Privé opnamen en stortingen: Specificatie */
    eigenVermogenNatuurlijkPersoonPriveOpnamenStortingenSpecificatie: EigenVermogenNatuurlijkPersoonPriveOpnameStorting[];
    /** Tekstuele toelichting eigen vermogen natuurlijk persoon */
    eigenVermogenNatuurlijkPersoonTekstueel?: EigenVermogenNatuurlijkPersoonTekstueel;

    [key: string]: any;
}

/** Eigen vermogen natuurlijk persoon - Mutatieoverzicht */
export interface EigenVermogenNatuurlijkPersoonMutatieoverzicht {
    privateIntakesNaturalPersons?: MonetaryNoDecimalsPeriodValues;
    privateDepositesNaturalPersons?: MonetaryNoDecimalsPeriodValues;
    equityResultAllocation?: BalanceItem;
    oldAgeTaxAllowanceAddition?: MonetaryNoDecimalsPeriodValues;
    oldAgeTaxAllowanceWithdrawal?: MonetaryNoDecimalsPeriodValues;
    equityMovementOther?: BalanceItem;
    equityMovement?: MonetaryNoDecimalsPeriodValues;
    equity?: MonetaryNoDecimalsPeriodValues;
    interestOnCapitalPercentage?: PercentPeriodValues;
    remunerationAllowance?: MonetaryNoDecimalsPeriodValues;
    shareInResultPercentage?: PercentPeriodValues;

    [key: string]: any;
}

/** Eigen vermogen natuurlijk persoon - Privé opnamen en stortingen: Specificatie */
export interface EigenVermogenNatuurlijkPersoonPriveOpnameStorting {
    privateDepositesIntakesDescriptionTypedMember: String255;
    privateIntakesNaturalPersons?: MonetaryNoDecimalsPeriodValues;
    privateDepositesNaturalPersons?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Tekstuele toelichting eigen vermogen natuurlijk persoon */
export interface EigenVermogenNatuurlijkPersoonTekstueel {
  equityNaturalPersonDisclosure?: FormattedExplanation;

  [key: string]: any;
}

/** Eigen vermogen natuurlijke personen */
export interface EigenVermogenNatuurlijkePersonen {
    equityBusinessNaturalPersons? : BalanceItem;
  /** Eigen vermogen natuurlijke personen: specificatie */
    eigenVermogenNatuurlijkePersonenSpecificatie?: EigenVermogenNatuurlijkPersoon[];
    eigenVermogenNatuurlijkePersonenPriveOpnamenStortingen?: EigenVermogenNatuurlijkePersonenPriveOpnamenStortingen;
    eigenVermogenNatuurlijkePersonenInstellingen?: EigenVermogenNatuurlijkePersonenInstellingen;

    [key: string]: any;
}

/** Instellingen m.b.t. eigen vermogen natuurlijke personen */
export interface EigenVermogenNatuurlijkePersonenInstellingen {
    [key: string]: any;
}

/** Privé opnamen en stortingen natuurlijke personen */
export interface EigenVermogenNatuurlijkePersonenPriveOpnamenStortingen {
    privateIntakesNaturalPersons?: MonetaryNoDecimalsPeriodValues;
    privateDepositesNaturalPersons?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Tekstuele toelichting eigen vermogen */
export interface EigenVermogenTekstueel {
    equityDisclosure?: FormattedExplanation;
    equityContinuityDisclosure?: FormattedExplanation;
    equityImportantSubsequentEventsDisclosure?: FormattedExplanation;
    guaranteedEquityDisclosure?: FormattedExplanation;
    liableEquityCapitalDisclosure?: FormattedExplanation;
    mostImportantConditionsFinancialInstrumentsLegalFormClassifiedAsEquityDescription?: FormattedExplanation;
    amountOfOverdueDividentPreferentialSharesDescription?: FormattedExplanation;
    equityWithheldPartResultDescription?: FormattedExplanation;

    [key: string]: any;
}

/** E-mailadres, volledig */
export interface Email {
    value?: string;

    [key: string]: any;
}

/** Exploitatiesubsidies */
export interface Exploitatiesubsidies {
    exploitationSubsidies?: BalanceItem;
    exploitatiesubsidiesTekstueel?: ExploitatiesubsidiesTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting exploitatiesubsidies */
export interface ExploitatiesubsidiesTekstueel {
    exploitationSubsidiesDisclosure?: FormattedExplanation;
    exploitationSubsidiesRecordedAsOperatingIncome?: FormattedExplanation;
    exploitationSubsidiesRecordedAsDeductionOfCosts?: FormattedExplanation;

    [key: string]: any;
}

/** Jaarrekening bevat financiële informatie van een individuele rechtspersoon dan wel een groep van maatschappijen */
export interface FinancialStatement {
    value?: FinancialStatementValue;

    [key: string]: any;
}

/** Financiële baten en lasten */
export interface FinancieleBatenLasten {
    financialIncomeExpenses?: MonetaryNoDecimalsPeriodValues;
    financieleBatenLastenUitsplitsing?: FinancieleBatenLastenUitsplitsing;
    financieleBatenLastenTekstueel?: FinancieleBatenLastenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting financiële baten en lasten */
export interface FinancieleBatenLastenTekstueel {
    financialIncomeExpensesDisclosure?: FormattedExplanation;
    incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosure?: FormattedExplanation;
    changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosure?: FormattedExplanation;
    interestIncomeRelatedIncomeDisclosure?: FormattedExplanation;
    interestExpensesRelatedExpensesDisclosure?: FormattedExplanation;
    foreignCurrencyExchangeRateResultsDisclosure?: FormattedExplanation;
    interestExpensesInterestCapitalisedDuringPeriodDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing financiële baten en lasten */
export interface FinancieleBatenLastenUitsplitsing {
    incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValue?: BalanceItem;
    opbrengstenAndereEffectenEnVorderingenVa?: OpbrengstenAndereEffectenEnVorderingenVa;
    interestIncomeRelatedIncome?: BalanceItem;
    amortisationSharePremiumDiscounts?: BalanceItem;
    favourableDifferenceReceivedAmountPrincipalAmount?: BalanceItem;
    unfavourableDifferenceReceivedAmountPrincipalAmount?: BalanceItem;
    waardeveranderingenFvaEnVanEffecten?: WaardeveranderingenFvaEnVanEffecten;
    changesValueParticipatingInterestsNotValuedAtNetAssetValue?: BalanceItem;
    positiveRevaluationsOfPuttableFinancialInstruments?: BalanceItem;
    negativeRevaluationsOfPuttableFinancialInstruments?: BalanceItem;
    interestExpensesRelatedExpenses?: BalanceItem;
    redemptionPremiums?: BalanceItem;
    emissionCosts?: BalanceItem;
    earlyRedemptionCosts?: BalanceItem;
    additionalCostsFinancing?: BalanceItem;
    currencyDifferencesLoansConsideredAsCorrectionInterestChargesDue?: BalanceItem;
    interestExpensesIncludedLeaseTermFinancialLeasing?: BalanceItem;
    foreignCurrencyExchangeRateResults?: BalanceItem;

    [key: string]: any;
}

/** Financiële instrumenten */
export interface FinancieleInstrumenten {
    financieleInstrumentenTekstueel?: FinancieleInstrumentenTekstueel;

    [key: string]: any;
}

/** Financiële instrumenten */
export interface FinancieleInstrumentenAlgemeneGrondslagen {
    financieleInstrumentenTekstueel?: FinancieleInstrumentenAlgemeneGrondslagenTekstueel;

    [key: string]: any;
}

/** Grondslagen financiële instrumenten */
export interface FinancieleInstrumentenAlgemeneGrondslagenTekstueel {
    financialInstrumentsPolicy?: FormattedExplanationPolicy;
    financialInstrumentsHedgeAccountingPolicy?: FormattedExplanationPolicy;
    financialInstrumentsCurrentValuePolicy?: FormattedExplanationPolicy;
    financialInstrumentsFairValuePolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Financiële instrumenten die op basis van de economische realiteit als vreemd vermogen zouden worden verantwoord maar op basis van de juridische vorm als eigen vermogen worden verantwoord */
export interface FinancieleInstrumentenEigenVermogen {
    financialInstrumentsLegalFormClassifiedAsEquity?: BalanceItem;
    financieleInstrumentenEigenVermogenTekstueel?: FinancieleInstrumentenEigenVermogenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting financiële instrumenten eigen vermogen */
export interface FinancieleInstrumentenEigenVermogenTekstueel {
    financialInstrumentsLegalFormClassifiedAsEquityDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Tekstuele toelichting financiële instrumenten */
export interface FinancieleInstrumentenTekstueel {
    financialInstrumentsDisclosure?: FormattedExplanation;
    financialInstrumentsBookValueDisclosure?: FormattedExplanation;
    financialInstrumentsBookValueHigherThanFairValueDisclosure?: FormattedExplanation;
    financialAssetsBookValueHigherThanCurrentValueDisclosure?: FormattedExplanation;
    financialLiabilitiesNoncurrentBookValueHigherThanFairValueDisclosure?: FormattedExplanation;
    financialInstrumentsRepricingOrRepaymentDatesAndEffectiveInterestRatesDisclosure?: FormattedExplanation;
    financialInstrumentsCurrentValueDescription?: FormattedExplanation;
    derivativeFinancialInstrumentsDisclosure?: FormattedExplanation;
    derivativeFinancialInstrumentsNatureAndExtentDescription?: FormattedExplanation;
    derivativeFinancialInstrumentsTermsAndConditionsThatMayAffectFutureCashFlows?: FormattedExplanation;
    compoundFinancialInstrumentsDisclosure?: FormattedExplanation;
    financialInstrumentsRiskManagementCashFlowRisksDisclosure?: FormattedExplanation;
    financialInstrumentsRiskManagementLiquidityRisksDisclosure?: FormattedExplanation;
    financialInstrumentsRiskManagementCreditRisksDisclosure?: FormattedExplanation;
    financialInstrumentsRiskManagementPriceRisksDisclosure?: FormattedExplanation;
    financialInstrumentsRiskManagementInterestRisksDisclosure?: FormattedExplanation;
    financialInstrumentsPutUpAsCollateralForDebtsDescription?: FormattedExplanation;
    financialInstrumentsIssuedCurrencyOfReceiptsPaymentsDescription?: FormattedExplanation;
    financialInstrumentsIssuedInstrumentsExchangedDescription?: FormattedExplanation;
    financialInstrumentsIssuedConditionsRelatedProvisionsDescription?: FormattedExplanation;
    financialInstrumentsObtainedExercisePriceOrRangeDescription?: FormattedExplanation;
    financialInstrumentsObtainedOptionsForEarlySettlementDescription?: FormattedExplanation;
    financialInstrumentsObtainedOptionsForConversionExchangeDescription?: FormattedExplanation;
    financialInstrumentsIssuedObtainedSecuritiesDescription?: FormattedExplanation;
    financialInstrumentsInterestRelatedIncomeExpenseDisclosure?: FormattedExplanation;
    financialInstrumentsObtainedSecuritiesDescription?: FormattedExplanation;
    financialInstrumentsSecuritisationRepurchaseAgreementDisclosure?: FormattedExplanation;
    financialInstrumentsContractualConditionsDescription?: FormattedExplanation;
    financialInstrumentsExtentDescription?: FormattedExplanation;
    financialInstrumentsIssuedAgreedInterestRateOrAmountOfInterestOrDividendOrOthersDescription?: FormattedExplanation;
    financialInstrumentsIssuedAmountsAndTimingsExpectedFutureReceiptsPrincipalAmountDescription?: FormattedExplanation;
    financialInstrumentsNatureDescription?: FormattedExplanation;
    financialInstrumentsIssuedExercisePriceOrRangeDescription?: FormattedExplanation;
    financialInstrumentsIssuedOptionsForEarlySettlementDescription?: FormattedExplanation;
    financialInstrumentsIssuedOptionsForConversionExchangeDescription?: FormattedExplanation;
    financialInstrumentsObtainedAmountsAndTimingsExpectedFutureReceiptsPrincipalAmountDescription?: FormattedExplanation;
    financialInstrumentsObtainedAgreedInterestRateOrAmountOfInterestOrDividendOrOthersDescription?: FormattedExplanation;
    financialInstrumentsObtainedCurrencyOfReceiptsPaymentsDescription?: FormattedExplanation;
    financialInstrumentsObtainedInstrumentsExchangedDescription?: FormattedExplanation;
    financialInstrumentsObtainedConditionsRelatedProvisionsDescription?: FormattedExplanation;
    financialInstrumentsMethodsAssumptionsFairValueEstimationDescription?: FormattedExplanation;
    financialInstrumentsAssetDisposalDescription?: FormattedExplanation;
    financialInstrumentsValuationDateDescription?: FormattedExplanation;
    financialInstrumentsHedgeAccountingDisclosure?: FormattedExplanation;
    financialInstrumentsImpactHedgeInstrumentsInterestCashflowLiquidityRisksDisclosure?: FormattedExplanation;
    financialInstrumentsHedgeIneffectivePartDisclosure?: FormattedExplanation;
    financialInstrumentsCurrencyRiskDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Financiële vaste activa */
export interface FinancieleVasteActiva {
    financialAssets?: MonetaryNoDecimalsPeriodValues;
    financieleVasteActivaUitsplitsing?: FinancieleVasteActivaUitsplitsing;
    financieleVasteActivaTekstueel?: FinancieleVasteActivaTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting financiële vaste activa */
export interface FinancieleVasteActivaTekstueel {
    financialAssetsDisclosure?: FormattedExplanation;
    financialAssetsFairValueDisclosure?: FormattedExplanation;
    natureExtentRestructuringDescription?: FormattedExplanation;
    assumptionsApproximationMethodAssetsValuedAtCurrentValueGenerateIncomeInvestmentDescription?: FormattedExplanation;
    approximationMethodAssetsValuedAtCurrentValueGenerateIncomeInvestmentDescription?: FormattedExplanation;
    financialAssetsImpairmentDescription?: FormattedExplanation;
    financialAssetsImpairmentReversalDescription?: FormattedExplanation;
    financialAssetsNoLegalOwnershipDescription?: FormattedExplanation;
    investmentsInParticipatingInterestsInGroupCompaniesDisclosure?: FormattedExplanation;
    presentationOfFinancialAssetsDeductibleWithinTwelveMonthsDescription?: FormattedExplanation;
    investmentsInParticipatingInterestsOtherDisclosure?: FormattedExplanation;
    investmentsOtherAffiliatedCompaniesDisclosure?: FormattedExplanation;
    receivablesGroupCompaniesNoncurrentDisclosure?: FormattedExplanation;
    financialAssetsDeductibleOrClaimableWithinTwelveMonthsDescription?: FormattedExplanation;
    receivablesOtherAffiliatedCompaniesNoncurrentDisclosure?: FormattedExplanation;
    receivablesShareholdersParticipatingInterestsNoncurrentDisclosure?: FormattedExplanation;
    legalEntityLossesOverReportingPeriodParticipatingInterestsDisclosure?: FormattedExplanation;
    cumulativeUnprocessedShareLossesParticipatingInterestsDisclosure?: FormattedExplanation;
    securitiesOtherNoncurrentDisclosure?: FormattedExplanation;
    receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrentDisclosure?: FormattedExplanation;
    receivablesOtherNoncurrentDisclosure?: FormattedExplanation;
    deferredTaxAssetsNoncurrentDisclosure?: FormattedExplanation;
    theApplicationForOrGrantedExemptionRelatingToTheNotificationOfParticipatingInterestsDescription?: FormattedExplanation;
    natureIndicationsUnderliesConvictionBookValueRealisedDescription?: FormattedExplanation;
    financialAssetsBookActualValueHigherThanCurrentValueDescription?: FormattedExplanation;
    reasonBookValueNotDeductedFinancialAssetsHigherThanCurrentValueDescription?: FormattedExplanation;
    adjustmentToPoliciesImpossibilityDescription?: FormattedExplanation;
    dilutionsGainsLossesNatureAndExtentDescription?: FormattedExplanation;
    dilutionsGainsLossesProcessingMethodDescription?: FormattedExplanation;
    reasonForNonApplicationBW2Article389Description?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie financiële vaste activa */
export interface FinancieleVasteActivaUitsplitsing {
    investmentsInParticipatingInterestsInGroupCompanies?: BalanceItem;
    investmentsInParticipatingInterestsOther?: BalanceItem;
    investmentsOtherAffiliatedCompanies?: BalanceItem;
    receivablesGroupCompaniesNoncurrent?: BalanceItem;
    receivablesOtherAffiliatedCompaniesNoncurrent?: BalanceItem;
    receivablesShareholdersParticipatingInterestsNoncurrent?: BalanceItem;
    securitiesOtherNoncurrent?: BalanceItem;
    receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersNoncurrent?: BalanceItem;
    receivablesOtherNoncurrent?: BalanceItem;
    deferredTaxAssetsNoncurrent?: BalanceItem;
    financialAssetsOther?: BalanceItem;

    [key: string]: any;
}

/** Nevenvestigingen */
export interface FormattedExplanation {
    value?: string;
    includeInKvkReport?: boolean;

    [key: string]: any;
}

/** Grondslag van kasstroomoverzicht */
export interface FormattedExplanationPolicy {
    value?: string;
    includeInKvkReport?: boolean;
    selected?: boolean;
    customPolicy?: boolean;

    [key: string]: any;
}

/** Foutherstel */
export interface Foutherstel {
    foutherstelTekstueel?: FoutherstelTekstueel;
    /** Specificatie van herstelde fouten */
    foutherstelSpecificatie?: FoutherstelHersteldeFout[];

    [key: string]: any;
}

/** Specificatie van herstelde fouten */
export interface FoutherstelHersteldeFout {
    priorPeriodErrorsTypedMember: String255;
    priorPeriodErrorsCorrectionEffectDescription?: FormattedExplanation;
    priorPeriodErrorsNatureAndExtentDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Grondslagen foutherstel */
export interface FoutherstelTekstueel {
    priorPeriodErrorsDisclosure?: FormattedExplanationPolicy;
    deviationPriorPeriodFiguresDueToRevisionDisclosure?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Fusies en overnames */
export interface FusiesOvernames {
    fusiesOvernamesTekstueel?: FusiesOvernamesTekstueel;
    /** Specificatie van fusies en overnames */
    fusiesOvernamesSpecificatie?: FusiesOvernamesFusieOvername[];

    [key: string]: any;
}

/** Specificatie van fusies en overnames */
export interface FusiesOvernamesFusieOvername {
    mergersAcquisitionsTypedMember: String255;
    mergersAcquisitionsAcquireeDescription?: FormattedExplanation;
    mergersAcquisitionsMethodProcessingDescription?: FormattedExplanation;
    mergersAcquisitionsDateAcquisition?: CustomDate;
    mergersAcquisitionsPercentageVotingRightsAcquired?: Percent;
    amountsOfAssetsLiabilitiesIntroducedEachPartiesOnMergerDateDescription?: FormattedExplanation;
    revenueOtherOperatingIncomeSpecialItemsNetProfitCompaniesOverPeriodPriorMergerDateDescription?: FormattedExplanation;
    mergersAcquisitionsDiscontinuedOperationsFollowingMergerAcquisitionDescription?: FormattedExplanation;
    acquisitionPurchasePrice?: MonetaryNoDecimals;
    acquisitionPurchasePriceDescription?: FormattedExplanation;
    goodwillTaxEffectAmortisationDescription?: FormattedExplanation;
    acquisitionEstimateFairValueIdentifiableAssetsLiabilitiesDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Tekstuele toelichting fusies en overnames */
export interface FusiesOvernamesTekstueel {
    mergersAcquisitionsDisclosure?: FormattedExplanation;
    mergersAndAcquisitionsRealizedAfterBalanceSheetDateDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Geactiveerde productie ten behoeve van het eigen bedrijf */
export interface GeactiveerdeProductieEigenBedrijf {
    capitalisedProductionCosts?: BalanceItem;

    [key: string]: any;
}

/** Gebeurtenissen na balansdatum */
export interface GebeurtenissenNaBalansdatum {
    gebeurtenissenNaBalansdatumTekstueel?: GebeurtenissenNaBalansdatumTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting gebeurtenissen na balansdatum */
export interface GebeurtenissenNaBalansdatumTekstueel {
    subsequentEventsDisclosure?: FormattedExplanation;
    materialConsequencesDefferedTaxesMainDifferencesTaxRateDescription?: FormattedExplanation;
    foreignCurrencyTranslationImpactChangesInExchangeRatesAfterBalanceSheetDateDescription?: FormattedExplanation;
    materialImpactDeferredTaxesSignificantChangesTaxRateLegislationAfterBalanceSheetDateExplanation?: FormattedExplanation;

    [key: string]: any;
}

/** Gemiddeld aantal werknemers */
export interface GemiddeldAantalWerknemers {
    gemiddeldAantalWerknemersUitsplitsing: GemiddeldAantalWerknemersUitsplitsing;
    gemiddeldAantalWerknemersTekstueel?: GemiddeldAantalWerknemersTekstueel;
    /** Specificatie gemiddeld aantal werknemers naar segment */
    segmentenGemiddeldAantalWerknemers?: SegmentGemiddeldAantalWerknemers[];

    [key: string]: any;
}

/** Tekstuele toelichting gemiddeld aantal werknemers */
export interface GemiddeldAantalWerknemersTekstueel {
    averageNumberEmployeesDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Gemiddeld aantal werknemers over de periode */
export interface GemiddeldAantalWerknemersUitsplitsing {
    averageNumberEmployeesNetherlands?: NonNegativeDecimalPeriodValues;
    averageNumberEmployeesAbroad?: NonNegativeDecimalPeriodValues;
    averageNumberEmployees: NonNegativeDecimalPeriodValues;

    [key: string]: any;
}

/** Informatieverschaffing over groepsvermogen */
export interface GroepsVermogenTekstueel {
    equityGroupDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Groepsverhoudingen */
export interface Groepsverhoudingen {
    groepsverhoudingenTekstueel?: GroepsverhoudingenTekstueel;
    /** Specificatie van groepsverhoudingen */
    groepsverhoudingenSpecificatie?: GroepsverhoudingenGroepsverhouding[];

    [key: string]: any;
}

/** Specificatie van groepsverhoudingen */
export interface GroepsverhoudingenGroepsverhouding {
    legalEntityTypedMember: String255;
    consolidatingParentName?: String1000;
    consolidatingParentLocation?: String1000;

    [key: string]: any;
}

/** Tekstuele toelichting groepsverhoudingen */
export interface GroepsverhoudingenTekstueel {
    groupStructureDisclosure?: FormattedExplanation;
    groupStructureUltimateParentName?: String1000;
    groupStructureUltimateParentLocation?: String1000;
    groupStructureLocationWhereToObtainCopyFinancialStatementsDescription?: FormattedExplanation;
    consolidatingParentName?: String1000;
    consolidatingParentLocation?: String1000;

    [key: string]: any;
}

/** Totaal van groepsvermogen */
export interface Groepsvermogen {
    equityGroup?: MonetaryNoDecimalsPeriodValues;
    groepsVermogenTekstueel?: GroepsVermogenTekstueel;

    [key: string]: any;
}

/** Grondslagen */
export interface Grondslagen {
    grondslagenBalans?: GrondslagenBalans;
    grondslagenWinstEnVerliesrekening?: GrondslagenWinstEnVerliesrekening;
    grondslagenKasstroomoverzicht?: GrondslagenKasstroomoverzicht;

    [key: string]: any;
}

/** Grondslagen voor de waarderig van activa en passiva */
export interface GrondslagenBalans {
    intangibleAssetsPolicy?: FormattedExplanationPolicy;
    impairmentIntangibleAssetsPolicy?: FormattedExplanationPolicy;
    impairmentIntangibleAssetsReversalPolicy?: FormattedExplanationPolicy;
    costsIncorporationShareIssuePolicy?: FormattedExplanationPolicy;
    developmentCostsPolicy?: FormattedExplanationPolicy;
    patentsTrademarksOtherRightsPolicy?: FormattedExplanationPolicy;
    goodwillPolicy?: FormattedExplanationPolicy;
    prepaymentsIntangibleAssetsPolicy?: FormattedExplanationPolicy;
    intangibleAssetsOtherPolicy?: FormattedExplanationPolicy;
    propertyPlantEquipmentPolicy?: FormattedExplanationPolicy;
    impairmentPropertyPlantEquipmentPolicy?: FormattedExplanationPolicy;
    impairmentPropertyPlantEquipmentReversalPolicy?: FormattedExplanationPolicy;
    landAndBuildingsPolicy?: FormattedExplanationPolicy;
    machineryPolicy?: FormattedExplanationPolicy;
    tangibleAssetsOtherPolicy?: FormattedExplanationPolicy;
    constructionInProgressPrepaymentsPropertyPlantEquipmentPolicy?: FormattedExplanationPolicy;
    propertyPlantEquipmentNotUsedInOperationsPolicy?: FormattedExplanationPolicy;
    inventoriesRealisableValuePolicy?: FormattedExplanationPolicy;
    processingRepairAndMaintenanceCostsPolicy?: FormattedExplanationPolicy;
    investmentPropertiesPolicy?: FormattedExplanationPolicy;
    impairmentInvestmentPropertiesPolicy?: FormattedExplanationPolicy;
    realEstateInDevelopmentPolicy?: FormattedExplanationPolicy;
    investmentPropertiesInExploitationPolicy?: FormattedExplanationPolicy;
    financialAssetsPolicy?: FormattedExplanationPolicy;
    impairmentFinancialAssetsPolicy?: FormattedExplanationPolicy;
    impairmentFinancialAssetsReversalPolicy?: FormattedExplanationPolicy;
    investmentsInParticipatingInterestsInGroupCompaniesPolicy?: FormattedExplanationPolicy;
    investmentsOtherAffiliatedCompaniesPolicy?: FormattedExplanationPolicy;
    receivablesGroupCompaniesPolicy?: FormattedExplanationPolicy;
    receivablesOtherAffiliatedCompaniesPolicy?: FormattedExplanationPolicy;
    investmentsInParticipatingInterestsOtherPolicy?: FormattedExplanationPolicy;
    receivablesShareholdersParticipatingInterestsPolicy?: FormattedExplanationPolicy;
    receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersPolicy?: FormattedExplanationPolicy;
    securitiesOtherNoncurrentPolicy?: FormattedExplanationPolicy;
    receivablesOtherPolicy?: FormattedExplanationPolicy;
    receivablesIncomeTaxPolicy?: FormattedExplanationPolicy;
    deferredTaxAssetsPolicy?: FormattedExplanationPolicy;
    financialAssetsOtherPolicy?: FormattedExplanationPolicy;
    assetsNoncurrentPolicy?: FormattedExplanationPolicy;
    impairmentAssetsNoncurrentPolicy?: FormattedExplanationPolicy;
    impairmentAssetsNoncurrentReversalPolicy?: FormattedExplanationPolicy;
    changesInValueNoncurrentSecuritiesInvestmentsInParticipatingInterestsDebitPolicy?: FormattedExplanationPolicy;
    inventoriesPolicy?: FormattedExplanationPolicy;
    inventoryRawMaterialsConsumablesPolicy?: FormattedExplanationPolicy;
    workInProgressPolicy?: FormattedExplanationPolicy;
    inventoryFinishedTradeGoodsPolicy?: FormattedExplanationPolicy;
    prepaymentsInventoriesPolicy?: FormattedExplanationPolicy;
    agriculturalInventoriesCurrentValuePolicy?: FormattedExplanationPolicy;
    constructionContractsPolicy?: FormattedExplanationPolicy;
    receivablesPolicy?: FormattedExplanationPolicy;
    tradeReceivablesPolicy?: FormattedExplanationPolicy;
    calledUpShareCapitalPolicy?: FormattedExplanationPolicy;
    pensionReceivablesPolicy?: FormattedExplanationPolicy;
    taxReceivablesPolicy?: FormattedExplanationPolicy;
    accruedIncomePolicy?: FormattedExplanationPolicy;
    securitiesCurrentPolicy?: FormattedExplanationPolicy;
    cashAndCashEquivalentsPolicy?: FormattedExplanationPolicy;
    assetsCurrentPolicy?: FormattedExplanationPolicy;
    equityPolicy?: FormattedExplanationPolicy;
    equityBusinessNaturalPersonsPolicy?: FormattedExplanationPolicy;
    shareCapitalPaidCalledUpPolicy?: FormattedExplanationPolicy;
    sharePremiumPolicy?: FormattedExplanationPolicy;
    revaluationReservePolicy?: FormattedExplanationPolicy;
    legalReservesPolicy?: FormattedExplanationPolicy;
    statutoryReservesPolicy?: FormattedExplanationPolicy;
    financialInstrumentsLegalFormClassifiedAsEquityPolicy?: FormattedExplanationPolicy;
    dividendPayableHoldersSharesRecordedAsEquityPolicy?: FormattedExplanationPolicy;
    preferredDividendDeductedFromResultForTheYearPolicy?: FormattedExplanationPolicy;
    reinvestmentReservePolicy?: FormattedExplanationPolicy;
    reservesOtherPolicy?: FormattedExplanationPolicy;
    otherFiscalReservesPolicy?: FormattedExplanationPolicy;
    retainedEarningsPolicy?: FormattedExplanationPolicy;
    resultForTheYearPolicy?: FormattedExplanationPolicy;
    equityGroupPolicy?: FormattedExplanationPolicy;
    noncontrollingInterestPolicy?: FormattedExplanationPolicy;
    provisionsPolicy?: FormattedExplanationPolicy;
    provisionRepairCostsPolicy?: FormattedExplanationPolicy;
    provisionPensionObligationsPolicy?: FormattedExplanationPolicy;
    provisionPensionObligationsActuarialAssumptionsDescription?: FormattedExplanationPolicy;
    provisionPensionObligationsDescription?: FormattedExplanationPolicy;
    provisionPensionObligationsValuationMethodsDescription?: FormattedExplanationPolicy;
    provisionTaxLiabilitiesPolicy?: FormattedExplanationPolicy;
    provisionEnvironmentalPolicy?: FormattedExplanationPolicy;
    provisionLegalProceedingsPolicy?: FormattedExplanationPolicy;
    provisionMajorMaintenancePolicy?: FormattedExplanationPolicy;
    provisionDisposalObligationPolicy?: FormattedExplanationPolicy;
    provisionOnerousContractsPolicy?: FormattedExplanationPolicy;
    provisionRestructuringPolicy?: FormattedExplanationPolicy;
    provisionParticipatingInterestsPolicy?: FormattedExplanationPolicy;
    deferredTaxLiabilitiesPolicy?: FormattedExplanationPolicy;
    provisionWarrantyPolicy?: FormattedExplanationPolicy;
    provisionJubileeBenefitsPolicy?: FormattedExplanationPolicy;
    provisionInsuranceDisabilityRisksPolicy?: FormattedExplanationPolicy;
    provisionDisabilityRisksPolicy?: FormattedExplanationPolicy;
    provisionInsuranceIllnessDisabilityPolicy?: FormattedExplanationPolicy;
    provisionShareBasedPaymentsPolicy?: FormattedExplanationPolicy;
    provisionEmployeeBenefitsPolicy?: FormattedExplanationPolicy;
    provisionsOtherPolicy?: FormattedExplanationPolicy;
    liabilitiesNoncurrentPolicy?: FormattedExplanationPolicy;
    subordinatedLiabilitiesPolicy?: FormattedExplanationPolicy;
    convertibleBorrowingsPolicy?: FormattedExplanationPolicy;
    debenturesOtherPrivateLoansPolicy?: FormattedExplanationPolicy;
    financeLeaseLiabilitiesPolicy?: FormattedExplanationPolicy;
    payablesBanksPolicy?: FormattedExplanationPolicy;
    advancesReceivedPolicy?: FormattedExplanationPolicy;
    tradePayablesPolicy?: FormattedExplanationPolicy;
    billsExchangeChequesPayablePolicy?: FormattedExplanationPolicy;
    payablesGroupCompaniesPolicy?: FormattedExplanationPolicy;
    payablesOtherAffiliatedCompaniesPolicy?: FormattedExplanationPolicy;
    payablesShareholdersParticipatingInterestsPolicy?: FormattedExplanationPolicy;
    payablesIncomeTaxCurrentPolicy?: FormattedExplanationPolicy;
    taxesSocialSecurityContributionsPayablePolicy?: FormattedExplanationPolicy;
    pensionPayablesPolicy?: FormattedExplanationPolicy;
    oldAgeObligationPolicy?: FormattedExplanationPolicy;
    taxPayablesPolicy?: FormattedExplanationPolicy;
    oldAgeTaxAllowanceFiscalPolicy?: FormattedExplanationPolicy;
    negativeGoodwillPolicy?: FormattedExplanationPolicy;
    payablesOtherPolicy?: FormattedExplanationPolicy;
    accrualsAndDeferredIncomePolicy?: FormattedExplanationPolicy;
    liabilitiesCurrentPolicy?: FormattedExplanationPolicy;
    repaymentObligationsOfNoncurrentBorrowingsPolicy?: FormattedExplanationPolicy;
    dividendPayableHoldersSharesRecordedAsLiabilityPolicy?: FormattedExplanationPolicy;
    payablesVacationDaysPolicy?: FormattedExplanationPolicy;
    payablesHolidayPayPolicy?: FormattedExplanationPolicy;
    constructionContractsLiabilitiesPolicy?: FormattedExplanationPolicy;
    payablesEmployeeBenefitsExpensesPolicy?: FormattedExplanationPolicy;
    dividendPayableHoldersPreferredSharesPolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Grondslagen kasstroomoverzicht */
export interface GrondslagenKasstroomoverzicht {
    cashFlowStatementPolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Grondslagen voor de bepaling van het resultaat */
export interface GrondslagenWinstEnVerliesrekening {
    accountingPrinciplesForDeterminingTheResult?: FormattedExplanationPolicy;
    incomeRecognitionPolicy?: FormattedExplanationPolicy;
    revenueRecognitionPolicy?: FormattedExplanationPolicy;
    grossMarginPolicy?: FormattedExplanationPolicy;
    netRevenuePolicy?: FormattedExplanationPolicy;
    revenuesFromSaleOfGoodsPolicy?: FormattedExplanationPolicy;
    revenuesFromProvidingServicesPolicy?: FormattedExplanationPolicy;
    changesInventoriesWorkInProgressPolicy?: FormattedExplanationPolicy;
    projectIncomePolicy?: FormattedExplanationPolicy;
    capitalisedProductionCostsPolicy?: FormattedExplanationPolicy;
    privateUseOwnBusinessCurrentPolicy?: FormattedExplanationPolicy;
    exploitationSubsidiesPolicy?: FormattedExplanationPolicy;
    operatingIncomeOtherPolicy?: FormattedExplanationPolicy;
    operatingIncomePolicy?: FormattedExplanationPolicy;
    costsRawMaterialsConsumablesPolicy?: FormattedExplanationPolicy;
    costsOutsourcedWorkOtherExternalExpensesPolicy?: FormattedExplanationPolicy;
    changeValueAgriculturalStocksPolicy?: FormattedExplanationPolicy;
    employeeBenefitsExpensesPolicy?: FormattedExplanationPolicy;
    wagesSalariesPolicy?: FormattedExplanationPolicy;
    severancePaymentsPolicy?: FormattedExplanationPolicy;
    socialSecurityContributionsPolicy?: FormattedExplanationPolicy;
    pensionCostsPolicy?: FormattedExplanationPolicy;
    employeeBenefitsExpensesOtherPolicy?: FormattedExplanationPolicy;
    nowArrangementPolicy?: FormattedExplanationPolicy;
    depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsPolicy?: FormattedExplanationPolicy;
    amortisationIntangibleAssetsPolicy?: FormattedExplanationPolicy;
    depreciationPropertyPlantEquipmentPolicy?: FormattedExplanationPolicy;
    changesInValueIntangibleAssetsPropertyPlantEquipmentPolicy?: FormattedExplanationPolicy;
    changesInValueIntangibleAssetsPolicy?: FormattedExplanationPolicy;
    changesInValuePropertyPlantEquipmentPolicy?: FormattedExplanationPolicy;
    realisedChangesInValueOfInvestmentsPolicy?: FormattedExplanationPolicy;
    unrealisedChangesInValueOfInvestmentsPolicy?: FormattedExplanationPolicy;
    changesValueInvestmentPropertiesPolicy?: FormattedExplanationPolicy;
    impairmentCurrentAssetsPolicy?: FormattedExplanationPolicy;
    accommodationCostsPolicy?: FormattedExplanationPolicy;
    operatingExpensesOtherPolicy?: FormattedExplanationPolicy;
    operatingExpensesPolicy?: FormattedExplanationPolicy;
    incomeReceivablesNoncurrentSecuritiesPolicy?: FormattedExplanationPolicy;
    revaluationReserveReleasePolicy?: FormattedExplanationPolicy;
    governmentSubsidiesPolicy?: FormattedExplanationPolicy;
    changesValueFinancialAssetsSecuritiesPolicy?: FormattedExplanationPolicy;
    interestIncomeRelatedIncomePolicy?: FormattedExplanationPolicy;
    interestExpensesRelatedExpensesPolicy?: FormattedExplanationPolicy;
    capitalizedInterestExpensesPolicy?: FormattedExplanationPolicy;
    valueChangesFinancialInstrumentsValuedAtFairValuePolicy?: FormattedExplanationPolicy;
    financialIncomeExpensesPolicy?: FormattedExplanationPolicy;
    incomeTaxExpensePolicy?: FormattedExplanationPolicy;
    decreaseInValueDeferredTaxAssetsPolicy?: FormattedExplanationPolicy;
    incomeTaxExpenseOtherPolicy?: FormattedExplanationPolicy;
    shareInResultsParticipatingInterestsPolicy?: FormattedExplanationPolicy;
    resultEntityPolicy?: FormattedExplanationPolicy;
    resultAttributableNoncontrollingInterestPolicy?: FormattedExplanationPolicy;
    earningsPerSharePolicy?: FormattedExplanationPolicy;
    shareInResultsPartnersPolicy?: FormattedExplanationPolicy;
    earningsToBeDistributedPolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Herinvesteringsreserve */
export interface HerinvesteringsreserveJaarstukken {
    reinvestmentReserve?: BalanceItem;
    herinvesteringsreserveTekstueel?: HerinvesteringsreserveTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting herinvesteringsreserve */
export interface HerinvesteringsreserveTekstueel {
    reinvestmentReserveDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Herwaarderingsreserves */
export interface Herwaarderingsreserve {
    revaluationReserve?: BalanceItem;
    herwaarderingsreserveTekstueel?: HerwaarderingsreserveTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting herwaarderingsreserve */
export interface HerwaarderingsreserveTekstueel {
    revaluationReserveDisclosure?: FormattedExplanation;
    impactTaxesCapitalIncomeDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Immateriële vaste activa */
export interface ImmaterieleVasteActiva {
    intangibleAssets?: MonetaryNoDecimalsPeriodValues;
    immaterieleVasteActivaUitsplitsing?: ImmaterieleVasteActivaUitsplitsing;
    immaterieleVasteActivaTekstueel?: ImmaterieleVasteActivaTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting immateriële vaste activa */
export interface ImmaterieleVasteActivaTekstueel {
    intangibleAssetsDisclosure?: FormattedExplanation;
    intangibleAssetsCurrentValueDisclosure?: FormattedExplanation;
    intangibleAssetsLimitedOwnershipDescription?: FormattedExplanation;
    developmentCostsDisclosure?: FormattedExplanation;
    intangibleAssetsCostsOfResearchAndDevelopmentIncludedInTheResultForTheFinancialPeriodDescription?: FormattedExplanation;
    intangibleAssetsPutUpAsCollateralForDebtsDescription?: FormattedExplanation;
    intangibleAssetsImpairmentDescription?: FormattedExplanation;
    intangibleAssetsImpairmentReversalDescription?: FormattedExplanation;
    patentsTrademarksOtherRightsDisclosure?: FormattedExplanation;
    goodwillDisclosure?: FormattedExplanation;
    goodwillIncomeStatementLineItemWhereAmortisationRecognisedDescription?: FormattedExplanation;
    goodwillReasonAndFactsDeterminingAmortisationTermOfTenYearsAtMost?: FormattedExplanation;
    goodwillReasonAndFactsDeterminingAmortisationTermOfMoreThanTwentyYearsDescription?: FormattedExplanation;
    intangibleAssetsCommitmentsRelatingToAdditionsThroughAcquisitionsDescription?: FormattedExplanation;
    intangibleAssetsInterestCapitalisedDuringPeriodDescription?: FormattedExplanation;
    prepaymentsIntangibleAssetsDisclosure?: FormattedExplanation;
    intangibleAssetsOtherDisclosure?: FormattedExplanation;
    actualCostPriceDeterminationIntangibleAssetsDescription?: FormattedExplanation;
    valueInUseDeterminationIntangibleAssetsDescription?: FormattedExplanation;
    realisableValueDeterminationIntangibleAssetsDescription?: FormattedExplanation;
    intangibleAssetsReasonAndFactsDeterminingAmortisationTermExceedingTwentyYearsDescription?: FormattedExplanation;
    intangibleAssetsIndividualAssetOfImportanceDescription?: FormattedExplanation;
    intangibleAssetsIncomeStatementLineItemWhereAmortisationRecognisedDescription?: FormattedExplanation;
    intangibleAssetsNoLegalOwnershipDescription?: FormattedExplanation;
    intangibleAssetsFullyAmortisedAssetsDescription?: FormattedExplanation;
    intangibleAssetsNotRecordedOnBalanceDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie immateriële vaste activa */
export interface ImmaterieleVasteActivaUitsplitsing {
    costsIncorporationShareIssue?: BalanceItem;
    developmentCosts?: BalanceItem;
    patentsTrademarksOtherRights?: BalanceItem;
    goodwill?: BalanceItem;
    prepaymentsIntangibleAssets?: BalanceItem;
    intangibleAssetsOther?: BalanceItem;

    [key: string]: any;
}

/** Type winst-en-verliesrekening */
export interface IncomeStatementClassification {
    value?: IncomeStatementClassificationValue;

    [key: string]: any;
}

/** Informatie over de entiteit */
export interface InformatieEntiteit {
    legalEntityName: String1000;
    legalEntityLegalForm: LegalForm;
    legalEntityLegalFormNPOtherDescription?: FormattedExplanation;
    legalEntityRegisteredOffice: String1000;
    chamberOfCommerceRegistrationNumber: ChamberOfCommerceRegistrationNumber;
    businessNames?: String1000;
    legalSizeCriteriaClassification: LegalSizeCriteria;
    sbiBusinessCode?: Sbi;
    dateEstablishmentLegalEntity?: CustomDate;
    dateChangeRegulationsLegalEntity?: CustomDate;
    numberOfBusinessPartnersInFTEsDecimals?: NonNegativeDecimal;
    adres: AdresEntiteit;

    [key: string]: any;
}

/** Informatie over de rapportage */
export interface InformatieRapportage {
    titleOfTheDocument?: String1000;
    financialReportingPeriodCurrentStartDate?: CustomDate;
    financialReportingPeriodCurrentEndDate?: CustomDate;
    financialReportingPeriodPreviousStartDate?: CustomDate;
    financialReportingPeriodPreviousEndDate?: CustomDate;
    financialReportingPeriodDifferentThanAnnualStatus?: YesNo;
    financialReportingPeriodDifferentThanAnnualReason?: FormattedExplanation;
    financialReportingPeriodDifferentThanAnnualImpactComparatives?: FormattedExplanation;
    documentRelatesToIndividualEntityOrGroup?: FinancialStatement;
    documentPresentationCurrency?: IsoCurrencyCodes4217;
    documentIntendedRoundingLevel?: NonNegativeInteger;
    basisOfPreparation?: BasisOfPreparation;
    incomeStatementClassificationType?: IncomeStatementClassification;
    cashFlowStatementMethodType?: CashFlowStatementMethod;
    financialStatementsDateOfPreparation?: CustomDate;
    documentAdoptionStatus?: YesNo;
    documentAdoptionDate?: CustomDate;
    documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuracies?: YesNo;
    documentResubmissionDueToTechnicalAndOrProcesRelatedInaccuraciesExplanation?: String1000;
    documentResubmissionDueToUnsurmountableInaccuracies?: YesNo;
    documentResubmissionDueToUnsurmountableInaccuraciesExplanation?: String1000;
    emailAddressFull?: Email;
    publicationWNTInTheConsolidatedStatutoryAccounts?: PublicationWNTfinancialStatement;
    referenceToTheSeniorOfficialsAndCorrespondingStatutoryEntities?: FormattedExplanation;
    applicableMaximumRemunerationInstitution?: MonetaryNoDecimals;

    [key: string]: any;
}

/** Rapporteringsvaluta van het document */
export interface IsoCurrencyCodes4217 {
    value?: string;

    [key: string]: any;
}

/** Jaarrapportage */
export interface Jaarrapportage {
    informatieEntiteit?: InformatieEntiteit;
    informatieRapportage?: InformatieRapportage;
    bestuursverslag?: Bestuursverslag;
    /** Jaarrekeningen */
    jaarrekeningen?: Jaarrekening[];
    overigeGegevens?: OverigeGegevens;
    /** Bestuurders en commissarissen */
    bestuurdersCommissarissen?: BestuurderCommissaris[];
    /** Zakelijke partners */
    zakelijkePartners?: ZakelijkePartner[];

    [key: string]: any;
}

/** Accountantsverklaring */
export interface Accountantsverklaring {
  informatieAccountantsverklaring: InformatieAccountantsverklaring;
  inhoudAccountantsverklaring: InhoudAccountantsverklaring;

  [key: string]: any;
}

/** InformatieAccountantsverklaring */
export interface InformatieAccountantsverklaring {
  informatieObjectVanOnderzoek: InformatieObjectVanOnderzoek;
  engagementType: EngagementType;
  internalReference?: String1000;
  entityIdentificationType: EntityIdentificationType;
  entityIdentification: String1000;
  softwarePackageName?: String1000;
  softwarePackageVersion?: String1000;

  [key: string]: any;
}

/** InformatieObjectVanOnderzoek */
export interface InformatieObjectVanOnderzoek {
  objectOfExaminationNatureDescription: FormattedExplanation;
  objectOfExaminationPeriodStartDate: CustomDate;
  objectOfExaminationPeriodEndDate: CustomDate;
  objectOfExaminationResponsibleOrganisationDescription: FormattedExplanation;

  [key: string]: any;
}

export interface EnrichAccountantsverklaringRequest{
  engagementType: EngagementType
  informatieEntiteit: InformatieEntiteit,
  informatieRapportage: InformatieRapportage
  uncertaintyAboutGoingConcern: boolean
  nbaAccountant: boolean
}

export interface EnrichGrondslagenResponse {
  algemeneGrondslagen: AlgemeneGrondslagen,
  grondslagen: Grondslagen
}

export interface EnrichGrondslagByIdResult {
  formattedExplanationPolicyId: string,
  value?: string
}

export interface EnrichGrondslagenRequest {
  jaarrekening: Jaarrekening
  informatieEntiteit: InformatieEntiteit,
  informatieRapportage: InformatieRapportage,
  formattedExplanationPolicyIds?: string[]
}

/** Type opdracht */
export interface EngagementType {
  value?: SoortOpdrachtType;

  [key: string]: any;
}

export enum SoortOpdrachtType {
  BEOORDELEN = "BEOORDELEN",
  BEOORDELEN_TUSSENTIJDS = "BEOORDELEN_TUSSENTIJDS",
  CONTROLE = "CONTROLE",
  SAMENSTELLEN = "SAMENSTELLEN",
}

/** Type identificatie */
export interface EntityIdentificationType {
  value?: EntiteitIdentificatieType;

  [key: string]: any;
}

export enum EntiteitIdentificatieType {
  KVK = "KVK",
  LEI = "LEI",
  RSIN = "RSIN",
}

/** InhoudAccountantsverklaring */
export interface InhoudAccountantsverklaring {
  auditorsReportHeader?: String1000;
  addressee?: String1000;
  introductoryParagraph?: FormattedExplanation;
  responsibilityTitle?: String1000;
  verantwoordelijkheidBestuurSpecificatie?: VerantwoordelijkheidBestuur[];
  verantwoordelijkheidAccountantSpecificatie?: VerantwoordelijkheidAccountant[];
  reportingTitle?: String1000;
  emphasisOfMatterUncertaintyAboutGoingConcern?: FormattedExplanation;
  benadrukkingVanAangelegenhedenSpecificatie?: BenadrukkingVanAangelegenheden[];
  toelichtendeParagraafSpecificatie?: ToelichtendeParagraaf[];
  handtekeningAccountantSpecificatie: HandtekeningAccountant[];

  [key: string]: any;
}

/** Specificatie van VerantwoordelijkheidBestuur */
export interface VerantwoordelijkheidBestuur {
  managementsResponsibility: FormattedExplanation;

  [key: string]: any;
}

/** Specificatie van VerantwoordelijkheidAccountant */
export interface VerantwoordelijkheidAccountant {
  professionalAccountantsResponsibility: FormattedExplanation;

  [key: string]: any;
}

/** Specificatie van BenadrukkingVanAangelegenheden */
export interface BenadrukkingVanAangelegenheden {
  emphasisOfMatter: FormattedExplanation;

  [key: string]: any;
}

/** Specificatie van ToelichtendeParagraaf */
export interface ToelichtendeParagraaf {
  otherMatter: FormattedExplanation;

  [key: string]: any;
}

/** Specificatie van HandtekeningAccountant */
export interface HandtekeningAccountant {
  professionalAccountantName: String255;
  professionalAccountantAddress: String1000;
  dateOfReport: CustomDate;
  firmName: String1000;

  [key: string]: any;
}

export interface JaarrapportageEntity {
    id?: number;
    year?: number;
    sstAdminId?: string;
    chamberOfCommerceNumber?: string;
    rapportage?: Jaarrapportage;
    accountantsverklaring?: Accountantsverklaring;
    kolommenbalans?: Kolommenbalans;
    dateCreation?: Date;
    lastOpeningDate?: Date;
    submissionDate?: Date;

    [key: string]: any;
}

/** Jaarrekeningen */
export interface Jaarrekening {
    /** Type jaarrekening */
    jaarrekeningType: JaarrekeningType;
    balans: Balans;
    winstEnVerliesrekening: WinstEnVerliesrekening;
    kasstroomoverzicht?: Kasstroomoverzicht;
    toelichting: Toelichting;

    [key: string]: any;
}

/** Kasstroomoverzicht */
export interface Kasstroomoverzicht {
    receiptsCustomers?: MonetaryNoDecimalsPeriodValues;
    paymentsSuppliers?: MonetaryNoDecimalsPeriodValues;
    paymentsEmployees?: MonetaryNoDecimalsPeriodValues;
    operatingResultCashFlow?: MonetaryNoDecimalsPeriodValues;
    adjustmentsDepreciationAndAmortisationExpense?: MonetaryNoDecimalsPeriodValues;
    adjustmentsImpairmentLossReversalImpairmentLossRecognisedInProfitLoss?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseProvisions?: MonetaryNoDecimalsPeriodValues;
    lineItemsOtherIncomeStatementReceiptsPaymentsNotConsideredOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    lineItemsOtherIncomeStatementNoImpactReceiptsPayments?: MonetaryNoDecimalsPeriodValues;
    adjustmentsReconcileOperatingResultOther?: MonetaryNoDecimalsPeriodValues;
    adjustmentsReconcileOperatingResult?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseInSecurities?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseInTradeAccountsReceivable?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseInInventories?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseInConstructionContracts?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseInTradeAccountsPayable?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseInOtherReceivables?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseInOtherPayables?: MonetaryNoDecimalsPeriodValues;
    changesWorkingCapital?: MonetaryNoDecimalsPeriodValues;
    cashFlowFromOperations?: MonetaryNoDecimalsPeriodValues;
    paymentsReclaimingValueAddedTax?: MonetaryNoDecimalsPeriodValues;
    paymentsInstallmentsOperationalLeasing?: MonetaryNoDecimalsPeriodValues;
    receiptsRoyaltiesCommissionAndSuch?: MonetaryNoDecimalsPeriodValues;
    paymentsPurchaseGoodsServices?: MonetaryNoDecimalsPeriodValues;
    paymentsProductionProcess?: MonetaryNoDecimalsPeriodValues;
    interestReceivedClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsReceivedClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    incomeTaxReceivedClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    receiptsPaymentValueAddedTax?: MonetaryNoDecimalsPeriodValues;
    interestPaidClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsPaidToShareholdersClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsPaidToMinorityInterestsClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsPaidOtherClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsPaidClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    incomeTaxPaidClassifiedAsOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    cashFlowsOperatingActivitiesOther?: MonetaryNoDecimalsPeriodValues;
    cashFlowOperatingActivities?: MonetaryNoDecimalsPeriodValues;
    purchaseGroupCompanies?: MonetaryNoDecimalsPeriodValues;
    proceedsSalesGroupCompanies?: MonetaryNoDecimalsPeriodValues;
    purchaseIntangibleAssets?: MonetaryNoDecimalsPeriodValues;
    proceedsSalesIntangibleAssets?: MonetaryNoDecimalsPeriodValues;
    purchasePropertyPlantEquipment?: MonetaryNoDecimalsPeriodValues;
    proceedsSalesPropertyPlantAndEquipment?: MonetaryNoDecimalsPeriodValues;
    purchaseInvestmentProperties?: MonetaryNoDecimalsPeriodValues;
    proceedsSalesInvestmentProperties?: MonetaryNoDecimalsPeriodValues;
    purchaseNonConsolidatedEntities?: MonetaryNoDecimalsPeriodValues;
    proceedsSalesNonconsolidatedEntities?: MonetaryNoDecimalsPeriodValues;
    paymentsCapitalizedDevelopmentCosts?: MonetaryNoDecimalsPeriodValues;
    purchaseLandBuildingsMachinesConcessionsParticipations?: MonetaryNoDecimalsPeriodValues;
    paymentsSelfMadeTangibleAssets?: MonetaryNoDecimalsPeriodValues;
    proceedsSalesIntangibleAssetsNotAccountedAsNetSales?: MonetaryNoDecimalsPeriodValues;
    paymentsProvisionRepaymentLongTermLoans?: MonetaryNoDecimalsPeriodValues;
    receiptsProvisionRepaymentLongTermLoans?: MonetaryNoDecimalsPeriodValues;
    paymentsInvestmentsNonShortTermHighlyLiquidSecurities?: MonetaryNoDecimalsPeriodValues;
    receiptsInvestmentsNonShortTermHighlyLiquidSecurities?: MonetaryNoDecimalsPeriodValues;
    purchaseOtherFinancialAssets?: MonetaryNoDecimalsPeriodValues;
    proceedsSalesOtherFinancialAssets?: MonetaryNoDecimalsPeriodValues;
    interestReceivedClassifiedAsInvestingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsReceivedClassifiedAsInvestingActivities?: MonetaryNoDecimalsPeriodValues;
    incomeTaxReceivedClassifiedAsInvestingActivities?: MonetaryNoDecimalsPeriodValues;
    interestPaidClassifiedAsInvestingActivities?: MonetaryNoDecimalsPeriodValues;
    incomeTaxPaidClassifiedAsInvestingActivities?: MonetaryNoDecimalsPeriodValues;
    cashFlowsInvestingActivitiesOther?: MonetaryNoDecimalsPeriodValues;
    cashFlowInvestingActivities?: MonetaryNoDecimalsPeriodValues;
    increaseDecreasePayablesCreditInstitutions?: MonetaryNoDecimalsPeriodValues;
    proceedsIssueShares?: MonetaryNoDecimalsPeriodValues;
    paymentsAcquireRedeemEntitysShares?: MonetaryNoDecimalsPeriodValues;
    proceedsFromBorrowings?: MonetaryNoDecimalsPeriodValues;
    proceedsFromBorrowingsDebentureLoans?: MonetaryNoDecimalsPeriodValues;
    proceedsFromBorrowingsPrivateLoans?: MonetaryNoDecimalsPeriodValues;
    proceedsFromBorrowingsMortgageLoans?: MonetaryNoDecimalsPeriodValues;
    proceedsFromSaleAndFinancialLeasebackTransaction?: MonetaryNoDecimalsPeriodValues;
    proceedsFromBorrowingsOtherLoans?: MonetaryNoDecimalsPeriodValues;
    repaymentsBorrowings?: MonetaryNoDecimalsPeriodValues;
    incomeTaxReceivedClassifiedAsFinancingActivities?: MonetaryNoDecimalsPeriodValues;
    interestPaidClassifiedAsFinancingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsPaidToShareholdersClassifiedAsFinancingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsPaidToMinorityInterestsClassifiedAsFinancingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsPaidOtherClassifiedAsFinancingActivities?: MonetaryNoDecimalsPeriodValues;
    dividendsPaidClassifiedAsFinancingActivities?: MonetaryNoDecimalsPeriodValues;
    incomeTaxPaidClassifiedAsFinancingActivities?: MonetaryNoDecimalsPeriodValues;
    cashFlowsFinancingActivitiesOther?: MonetaryNoDecimalsPeriodValues;
    cashFlowFinancingActivities?: MonetaryNoDecimalsPeriodValues;
    netCashFlows?: MonetaryNoDecimalsPeriodValues;
    proceedsCashObtainedAcquisition?: MonetaryNoDecimalsPeriodValues;
    effectExchangeRateChangesCashAndCashEquivalents?: MonetaryNoDecimalsPeriodValues;
    increaseDecreaseCashAndCashEquivalents?: MonetaryNoDecimalsPeriodValues;
    cashAndCashEquivalentsCashFlow?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Kortlopende schulden */
export interface KortlopendeSchulden {
    liabilitiesCurrent?: MonetaryNoDecimalsPeriodValues;
    kortlopendeSchuldenUitsplitsing?: KortlopendeSchuldenUitsplitsing;
    kortlopendeSchuldenTekstueel?: KortlopendeSchuldenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting kortlopende schulden */
export interface KortlopendeSchuldenTekstueel {
    liabilitiesCurrentDisclosure?: FormattedExplanation;
    subordinatedLiabilitiesCurrentNatureDescription?: FormattedExplanation;
    convertibleBorrowingsCurrentDisclosure?: FormattedExplanation;
    debenturesOtherPrivateLoansCurrentDisclosure?: FormattedExplanation;
    financeLeaseLiabilitiesCurrentDisclosure?: FormattedExplanation;
    payablesBanksCurrentDisclosure?: FormattedExplanation;
    advancesReceivedCurrentDisclosure?: FormattedExplanation;
    tradePayablesCurrentDisclosure?: FormattedExplanation;
    billsExchangeChequesPayableCurrentDisclosure?: FormattedExplanation;
    payablesGroupCompaniesCurrentDisclosure?: FormattedExplanation;
    payablesOtherAffiliatedCompaniesCurrentDisclosure?: FormattedExplanation;
    payablesShareholdersParticipatingInterestsCurrentDisclosure?: FormattedExplanation;
    payablesIncomeTaxCurrentDisclosure?: FormattedExplanation;
    taxesSocialSecurityContributionsPayableCurrentDisclosure?: FormattedExplanation;
    pensionPayablesCurrentDisclosure?: FormattedExplanation;
    repaymentObligationsOfNoncurrentBorrowingsDisclosure?: FormattedExplanation;
    dividendPayableHoldersSharesRecordedAsLiabilityDisclosure?: FormattedExplanation;
    constructionContractsLiabilitiesDisclosure?: FormattedExplanation;
    constructionContractsNoLegalOwnershipRecordedAsLiabilityDescription?: FormattedExplanation;
    constructionContractsMethodsProjectIncomeRecordedAsLiability?: FormattedExplanation;
    constructionContractsMethodRecordedAsLiability?: FormattedExplanation;
    constructionContractsActivatedCostsRecordedAsLiabilityDisclosure?: FormattedExplanation;
    transitionalProvisionConstructionContractsRecordedAsLiabilityDisclosure?: FormattedExplanation;
    payablesEmployeeBenefitsExpensesDisclosure?: FormattedExplanation;
    paidUnpaidRewardsToStaffDescription?: FormattedExplanation;
    payablesVacationDaysDisclosure?: FormattedExplanation;
    payablesHolidayPayDisclosure?: FormattedExplanation;
    dividendPayableHoldersPreferredSharesDisclosure?: FormattedExplanation;
    payablesOtherCurrentDisclosure?: FormattedExplanation;
    accrualsAndDeferredIncomeCurrentDisclosure?: FormattedExplanation;
    liabilitiesCurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosure?: FormattedExplanation;
    earlyRedemptionAfterBalanceSheetDateBeforePreparationOfFinancialStatementsDescription?: FormattedExplanation;
    amountNextExpiredRepaymentsDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie kortlopende schulden */
export interface KortlopendeSchuldenUitsplitsing {
    convertibleBorrowingsCurrent?: BalanceItem;
    debenturesOtherPrivateLoansCurrent?: BalanceItem;
    financeLeaseLiabilitiesCurrent?: BalanceItem;
    payablesBanksCurrent?: BalanceItem;
    advancesReceivedCurrent?: BalanceItem;
    tradePayablesCurrent?: BalanceItem;
    billsExchangeChequesPayableCurrent?: BalanceItem;
    payablesGroupCompaniesCurrent?: BalanceItem;
    payablesOtherAffiliatedCompaniesCurrent?: BalanceItem;
    payablesShareholdersParticipatingInterestsCurrent?: BalanceItem;
    payablesIncomeTaxCurrent?: BalanceItem;
    taxesSocialSecurityContributionsPayableCurrent?: BalanceItem;
    pensionPayablesCurrent?: BalanceItem;
    repaymentObligationsOfNoncurrentBorrowings?: BalanceItem;
    dividendPayableHoldersSharesRecordedAsLiability?: BalanceItem;
    constructionContractsLiabilities?: BalanceItem;
    payablesEmployeeBenefitsExpenses?: BalanceItem;
    payablesVacationDays?: BalanceItem;
    payablesHolidayPay?: BalanceItem;
    dividendPayableHoldersPreferredShares?: BalanceItem;
    payablesOtherCurrent?: BalanceItem;
    accrualsAndDeferredIncomeCurrent?: BalanceItem;

    [key: string]: any;
}

/** Kosten van grond- en hulpstoffen */
export interface KostenGrondEnHulpstoffen {
    costsRawMaterialsConsumables?: BalanceItem;

    [key: string]: any;
}

/** Kosten uitbesteed werk en andere externe kosten */
export interface KostenUitbesteedWerk {
    costsOutsourcedWorkOtherExternalExpenses?: BalanceItem;

    [key: string]: any;
}

/** Langlopende schulden */
export interface LanglopendeSchulden {
    liabilitiesNoncurrent?: MonetaryNoDecimalsPeriodValues;
    langlopendeSchuldenUitsplitsing?: LanglopendeSchuldenUitsplitsing;
    langlopendeSchuldenTekstueel?: LanglopendeSchuldenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting langlopende schulden */
export interface LanglopendeSchuldenTekstueel {
    liabilitiesNoncurrentDisclosure?: FormattedExplanation;
    subordinatedLiabilitiesNoncurrentDisclosure?: FormattedExplanation;
    subordinatedLiabilitiesNoncurrentNatureDescription?: FormattedExplanation;
    convertibleBorrowingsNoncurrentDisclosure?: FormattedExplanation;
    debenturesOtherPrivateLoansNoncurrentDisclosure?: FormattedExplanation;
    financeLeaseLiabilitiesNoncurrentDisclosure?: FormattedExplanation;
    financeLeasesImportantConditions?: FormattedExplanation;
    mainPurposeFinancialLeaseLessorDescription?: FormattedExplanation;
    legalPersonNotALegalOwnerDescription?: FormattedExplanation;
    payablesBanksNoncurrentDisclosure?: FormattedExplanation;
    advancesReceivedNoncurrentDisclosure?: FormattedExplanation;
    tradePayablesNoncurrentDisclosure?: FormattedExplanation;
    billsExchangeChequesPayableNoncurrentDisclosure?: FormattedExplanation;
    payablesGroupCompaniesNoncurrentDisclosure?: FormattedExplanation;
    payablesOtherAffiliatedCompaniesNoncurrentDisclosure?: FormattedExplanation;
    payablesShareholdersParticipatingInterestsNoncurrentDisclosure?: FormattedExplanation;
    taxesSocialSecurityContributionsPayableNoncurrentDisclosure?: FormattedExplanation;
    taxPayablesNoncurrentDisclosure?: FormattedExplanation;
    pensionPayablesNoncurrentDisclosure?: FormattedExplanation;
    oldAgeObligationDisclosure?: FormattedExplanation;
    negativeGoodwillDisclosure?: FormattedExplanation;
    negativeGoodwillFutureLossesDescription?: FormattedExplanation;
    negativeGoodwillIncomeStatementLineItemWhereRecognisedDescription?: FormattedExplanation;
    negativeGoodwillRecognitionPeriodIncomeStatementDescription?: FormattedExplanation;
    payablesOtherNoncurrentDisclosure?: FormattedExplanation;
    accrualsAndDeferredIncomeNoncurrentDisclosure?: FormattedExplanation;
    liabilitiesSecuredStatement?: FormattedExplanation;
    formCollateralProvidedTotalDebtsDescription?: FormattedExplanation;
    liabilitiesNoncurrentMaturityDisclosure?: FormattedExplanation;
    effectiveInterestRateOnLongtermDebtDisclosure?: FormattedExplanation;
    liabilitiesMaturityInterestRateDescription?: FormattedExplanation;
    liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosure?: FormattedExplanation;
    liabilitiesNoncurrentImmediateExigibilityDescription?: FormattedExplanation;
    bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescription?: FormattedExplanation;
    moneyOrSharesRedeemableLoansConditionsConversion?: FormattedExplanation;
    sharesRedeemableLoansConditionsConversion?: FormattedExplanation;
    warrantsAndWarrantsLoansConditionsConversion?: FormattedExplanation;
    convertibleBorrowingsConditionsConversion?: FormattedExplanation;
    indicationNatureDependenceAndFactorsNonFixedInterestRateDescription?: FormattedExplanation;
    progressionInterestRateInconsistentInterestRateRemainingMaturityDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie langlopende schulden */
export interface LanglopendeSchuldenUitsplitsing {
    convertibleBorrowingsNoncurrent?: BalanceItem;
    debenturesOtherPrivateLoansNoncurrent?: BalanceItem;
    financeLeaseLiabilitiesNoncurrent?: BalanceItem;
    payablesBanksNoncurrent?: BalanceItem;
    advancesReceivedNoncurrent?: BalanceItem;
    tradePayablesNoncurrent?: BalanceItem;
    billsExchangeChequesPayableNoncurrent?: BalanceItem;
    payablesGroupCompaniesNoncurrent?: BalanceItem;
    payablesOtherAffiliatedCompaniesNoncurrent?: BalanceItem;
    payablesShareholdersParticipatingInterestsNoncurrent?: BalanceItem;
    taxesSocialSecurityContributionsPayableNoncurrent?: BalanceItem;
    taxPayablesNoncurrent?: BalanceItem;
    pensionPayablesNoncurrent?: BalanceItem;
    oldAgeObligation?: BalanceItem;
    negativeGoodwill?: BalanceItem;
    payablesOtherNoncurrent?: BalanceItem;
    accrualsAndDeferredIncomeNoncurrent?: BalanceItem;
    payablesOtherNoncurrentSpecific?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Lasten uit hoofde van personeelsbeloningen */
export interface LastenUitHoofdePersoneelsbeloningen {
    employeeBenefitsExpenses?: MonetaryNoDecimalsPeriodValues;
    lastenUitHoofdePersoneelsbeloningenUitsplitsing?: LastenUitHoofdePersoneelsbeloningenUitsplitsing;
    lastenUitHoofdePersoneelsbeloningenTekstueel?: LastenUitHoofdePersoneelsbeloningenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting lasten uit hoofde van personeelsbeloningen */
export interface LastenUitHoofdePersoneelsbeloningenTekstueel {
    employeeBenefitsExpensesDisclosure?: FormattedExplanation;
    wagesSalariesDisclosure?: FormattedExplanation;
    severancePaymentsDisclosure?: FormattedExplanation;
    shareBasedPaymentsExpensesDisclosure?: FormattedExplanation;
    socialSecurityContributionsDisclosure?: FormattedExplanation;
    pensionCostsDisclosure?: FormattedExplanation;
    employeeBenefitsExpensesOtherDisclosure?: FormattedExplanation;
    processedWagesDescription?: FormattedExplanation;
    natureNowArrangementDescription?: FormattedExplanation;
    extentNowArrangementDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie lasten uit hoofde van personeelsbeloningen */
export interface LastenUitHoofdePersoneelsbeloningenUitsplitsing {
    wagesSalaries?: BalanceItem;
    severancePayments?: BalanceItem;
    shareBasedPaymentsIncludedWagesSalaries?: BalanceItem;
    socialSecurityContributions?: BalanceItem;
    pensionPremiums?: BalanceItem;
    pensionExpensesAdditional?: BalanceItem;
    pensionCosts?: MonetaryNoDecimalsPeriodValues;
    employeeBenefitsExpensesOther?: BalanceItem;

    [key: string]: any;
}

/** Leases */
export interface Leases {
    leasesTekstueel?: LeasesTekstueel;

    [key: string]: any;
}

/** Grondslagen leases */
export interface LeasesTekstueel {
    leasesPolicy?: FormattedExplanationPolicy;
    financeLeasesPolicy?: FormattedExplanationPolicy;
    operatingLeasesPolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Rechtsvorm van de entiteit */
export interface LegalForm {
    value?: LegalFormValue;

    [key: string]: any;
}

/** Classificatie van de rechtspersoon op basis van de wettelijke groottecriteria */
export interface LegalSizeCriteria {
    value?: LegalSizeCriteriaValue;

    [key: string]: any;
}

/** Leningen, voorschotten en garanties ten behoeve van bestuurders en commissarissen */
export interface LeningenBestuurdersCommissarissen {
    leningenVoorschottenGarantiesBestuurdersCommissarissenTekstueel?: LeningenBestuurdersCommissarissenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting leningen, voorschotten en garanties ten behoeve van bestuurders en commissarissen */
export interface LeningenBestuurdersCommissarissenTekstueel {
    loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosure?: FormattedExplanation;
    loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Liquide middelen */
export interface LiquideMiddelen {
    cashAndCashEquivalents?: MonetaryNoDecimalsPeriodValues;
    liquideMiddelenUitsplitsing?: LiquideMiddelenUitsplitsing;
    liquideMiddelenTekstueel?: LiquideMiddelenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting liquide middelen */
export interface LiquideMiddelenTekstueel {
    cashAndCashEquivalentsDisclosure?: FormattedExplanation;
    billsExchangeChequesDisclosure?: FormattedExplanation;
    cashAndCashEquivalentsUnavailableExplanation?: FormattedExplanation;
    cashAndCashEquivalentsNoLegalOwnershipDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing liquide middelen */
export interface LiquideMiddelenUitsplitsing {
    cashInHand?: BalanceItem;
    creditBalancesOnBankAccounts?: BalanceItem;
    billsExchangeCheques?: BalanceItem;

    [key: string]: any;
}

/** Materiële vaste activa */
export interface MaterieleVasteActiva {
    propertyPlantEquipment?: MonetaryNoDecimalsPeriodValues;
    materieleVasteActivaUitsplitsing?: MaterieleVasteActivaUitsplitsing;
    materieleVasteActivaTekstueel?: MaterieleVasteActivaTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting materiële vaste activa */
export interface MaterieleVasteActivaTekstueel {
    propertyPlantEquipmentDisclosure?: FormattedExplanation;
    propertyPlantEquipmentCurrentValueDisclosure?: FormattedExplanation;
    methodActualCostPricePropertyPlantEquipmentActualValueDescription?: FormattedExplanation;
    methodActualCostPricePropertyPlantEquipmentValueInUseDescription?: FormattedExplanation;
    methodActualCostPricePropertyPlantEquipmentRealisableValueDescription?: FormattedExplanation;
    landAndBuildingsDisclosure?: FormattedExplanation;
    machineryDisclosure?: FormattedExplanation;
    tangibleAssetsOtherDisclosure?: FormattedExplanation;
    constructionInProgressPrepaymentsPropertyPlantEquipmentDisclosure?: FormattedExplanation;
    propertyPlantEquipmentNotUsedInOperationsDisclosure?: FormattedExplanation;
    propertyPlantEquipmentLimitedOwnershipDescription?: FormattedExplanation;
    propertyPlantEquipmentNoLegalOwnershipDescription?: FormattedExplanation;
    propertyPlantEquipmentLimitedBusinessOrPersonalRightOfUseDescription?: FormattedExplanation;
    propertyPlantEquipmentPutUpAsCollateralForDebtsDescription?: FormattedExplanation;
    propertyPlantEquipmentPurchaseCommitmentsDescription?: FormattedExplanation;
    propertyPlantEquipmentImpairmentDescription?: FormattedExplanation;
    propertyPlantEquipmentImpairmentReversalDescription?: FormattedExplanation;
    propertyPlantEquipmentBookValueTemporarilyInactiveAssetsDisclosure?: FormattedExplanation;
    propertyPlantEquipmentGrossBookValueFullyDepreciatedStillInUseDisclosure?: FormattedExplanation;
    propertyPlantEquipmentBookValueInactiveHeldForSaleDisclosure?: FormattedExplanation;
    propertyPlantEquipmentCarryingAmountActualCostpriceNoLongerReliableDisclosure?: FormattedExplanation;
    propertyPlantEquipmentReimbursementThirdPartiesForDecreaseInValueOfAssetsDescription?: FormattedExplanation;
    propertyPlantEquipmentRepairCostsExpectationDescription?: FormattedExplanation;
    alternativeMethodIncomeExpenseDescription?: FormattedExplanation;
    propertyPlantEquipmentInterestCapitalisedDuringPeriodDescription?: FormattedExplanation;
    propertyPlantEquipmentFinanceLeaseDisclosure?: FormattedExplanation;
    propertyPlantEquipmentNatureAndExtentMovementsOtherDescription?: FormattedExplanation;
    propertyPlantEquipmentDeductionOfTheReinvestmentReserveFromTheAcquisitionOrProductionCostsOfAnAssetDisclosure?: FormattedExplanation;
    propertyPlantEquipmentPaymentIncludedInBookValueOfConstructionInProgressDescription?: FormattedExplanation;
    propertyPlantEquipmentMarketValueDescription?: FormattedExplanation;
    propertyPlantEquipmentCurrentValueIndependentAppraiserDescription?: FormattedExplanation;
    propertyPlantEquipmentCurrentValueDeterminationDescription?: FormattedExplanation;
    propertyPlantEquipmentCurrentValueMethodsAndSignificantAssumptionsDescription?: FormattedExplanation;
    propertyPlantEquipmentCurrentValueMethodsOfProcessingRevaluationsDescription?: FormattedExplanation;
    propertyPlantEquipmentCurrentValueYearOfRevaluationsDescription?: FormattedExplanation;
    changeAccountingPolicyToHistoricalCostPriceApplicationTransitionalProvisionDescription?: FormattedExplanation;
    extentNotRealisedRevaluationReserveDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie materiële vaste activa */
export interface MaterieleVasteActivaUitsplitsing {
    landAndBuildings?: BalanceItem;
    machinery?: BalanceItem;
    tangibleAssetsOther?: BalanceItem;
    constructionInProgressPrepaymentsPropertyPlantEquipment?: BalanceItem;
    propertyPlantEquipmentNotUsedInOperations?: BalanceItem;

    [key: string]: any;
}

/** De koopsom van de overname */
export interface MonetaryNoDecimals {
    value?: number;

    [key: string]: any;
}

/** Totaal van bezoldiging van een bestuurder of commissaris */
export interface MonetaryNoDecimalsPeriodValues {
    /** Value current period */
    valuePeriod1?: number;
    /** Value previous period */
    valuePeriod2?: number;

    [key: string]: any;
}

/** Netto-omzet */
export interface NettoOmzet {
    netRevenue?: MonetaryNoDecimalsPeriodValues;
    nettoOmzetUitsplitsing?: NettoOmzetUitsplitsing;

    [key: string]: any;
}

/** Uitsplitsing en specificatie netto-omzet */
export interface NettoOmzetUitsplitsing {
    revenuesFromSaleOfGoods?: BalanceItem;
    revenuesFromProvidingServices?: BalanceItem;
    revenuesFromInterest?: BalanceItem;
    revenuesFromRoyalties?: BalanceItem;
    revenuesFromDividends?: BalanceItem;
    revenuesFromLicenses?: BalanceItem;
    revenuesOther?: BalanceItem;

    [key: string]: any;
}

/** Nettoresultaat na belastingen toekomend aan de rechtspersoon */
export interface NettoresultaatNaBelastingen {
    netResultAfterTax?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Niet in de balans opgenomen activa en verplichtingen */
export interface NietInBalansOpgenomenActivaVerplichtingen {
    nietInBalansOpgenomenActivaVerplichtingenTekstueel?: NietInBalansOpgenomenActivaVerplichtingenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting niet in de balans opgenomen activa en verplichtingen */
export interface NietInBalansOpgenomenActivaVerplichtingenTekstueel {
    offBalanceSheetArrangementsDisclosure?: FormattedExplanation;
    offBalanceSheetCommitmentsDisclosure?: FormattedExplanation;
    conditionalIncomeExpenseDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsNatureDescription?: FormattedExplanation;
    offBalanceSheetArrangementsFinancialConsequencesDescription?: FormattedExplanation;
    offBalanceSheetArrangementsBusinessObjectiveDescription?: FormattedExplanation;
    offBalanceSheetArrangementsNatureDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsIndicationUncertaintiesAmountOrMomentOfOutflowDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsPossibilityOfAnyReimbursementDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsOnBehalfOfGroupCompaniesDisclosure?: FormattedExplanation;
    offBalanceSheetLiabilitiesLiabilityClaimDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsFiscalUnityDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsPurchaseCommitmentsDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsGuaranteesDescription?: FormattedExplanation;
    guaranteesJointSupervisoryDirectorsSubsidiariesAndConsolidatedCompaniesDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsPaymentsObtainUsageRightsDescription?: FormattedExplanation;
    guaranteesJointManagingDirectorsSubsidiariesAndConsolidatedCompaniesDescription?: FormattedExplanation;
    offBalanceSheetAssetsDisclosure?: FormattedExplanation;
    offBalanceSheetAssetsNotFeasibleDescription?: FormattedExplanation;
    offBalanceSheetCommitmentsEstimateFinancialEffectDescription?: FormattedExplanation;
    operatingLeasesDisclosure?: FormattedExplanation;
    operatingLeasesPaymentsDuringPeriodDisclosure?: FormattedExplanation;
    operatingLeasesImportantConditionsDescription?: FormattedExplanation;
    mainPurposeOperationalLeaseLessorDescription?: FormattedExplanation;
    operatingLeasesCommitmentsMaturityAverageDescription?: FormattedExplanation;
    operatingLeasesConditionalLeasePaymentsDescription?: FormattedExplanation;
    operatingLeasesOptionsClausesDescription?: FormattedExplanation;
    operatingLeasesConstraintsDescription?: FormattedExplanation;
    furtherDetailsPerCategoryLeaseDescription?: FormattedExplanation;
    contingentLiabilitiesIndividualLiabilitiesOfExceptionalImportanceDescription?: FormattedExplanation;
    liabilityDebtOfOthersDescription?: FormattedExplanation;
    unexpiredRisksDiscountedChequesBillsOfExchangeDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Niet verdeelde winsten */
export interface NietVerdeeldeWinsten {
    retainedEarnings?: BalanceItem;
    nietVerdeeldeWinstenTekstueel?: NietVerdeeldeWinstenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting niet verdeelde winsten */
export interface NietVerdeeldeWinstenTekstueel {
    retainedEarningsDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Postcode NL */
export interface NlZip {
    value?: string;

    [key: string]: any;
}

/** Nog niet uitgeoefende verleende rechten */
export interface NogNietUitgeoefendeVerleendeRechten {
    nogNietUitgeoefendeVerleendeRechtenTekstueel?: NogNietUitgeoefendeVerleendeRechtenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting nog niet uitgeoefende verleende rechten */
export interface NogNietUitgeoefendeVerleendeRechtenTekstueel {
    rightsGrantedNotYetExercisedDisclosure?: FormattedExplanation;
    rightsGrantedReasonsForGrantingRightsToSupervisoryDirectorsDescription?: FormattedExplanation;
    rightsGrantedCriteriaForGrantingOrExercisingRightsDescription?: FormattedExplanation;
    rightsGrantedConditionsRightsGrantedDuringFinancialYear?: FormattedExplanation;
    changesTermsRightsGrantedCompanyFinancialYearDisclosure?: FormattedExplanation;
    remainingTermRightsGrantedCompanyDuringFinancialYear?: NonNegativeInteger;
    rightsGrantedPurchaseOfTreasurySharesOrIssuanceOfNewSharesOnBehalfOfNewSharesIssuedDescription?: FormattedExplanation;
    rightsGrantedPurchaseOfTreasurySharesOrIssuanceOfNewSharesOnBehalfOfPurchasedOwnSharesDescription?: FormattedExplanation;
    rightsGrantedConditionsForExercisingRightsDescription?: FormattedExplanation;
    rightsGrantedFinancingArrangementDescription?: FormattedExplanation;
    rightsGrantedPurchaseOfTreasurySharesOrIssuanceOfNewSharesOnBehalfOfRightsGrantedDisclosure?: FormattedExplanation;
    rightsGrantedOtherRelevantInformationDescription?: FormattedExplanation;
    rightsGrantedHedgingDisclosure?: FormattedExplanation;
    rightsGrantedPolicyForHedgingDescription?: FormattedExplanation;
    rightsGrantedPurchaseCommitmentsDescription?: FormattedExplanation;
    rightsGrantedNotYetExercisedEndOfTheYearClaimRights?: FormattedExplanation;
    rightsGrantedNotYetHedgedDescription?: FormattedExplanation;
    amountCompanySharesPurchasedOrWillBePurchasedDescription?: FormattedExplanation;
    amountNewCompanySharesIssuedForPurposeOfExerciseRightsDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Nog te verdelen winst */
export interface NogTeVerdelenWinst {
    earningsToBeDistributed?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Aantal zakelijke partners in FTE's */
export interface NonNegativeDecimal {
    value?: number;

    [key: string]: any;
}

/** Gemiddeld aantal werknemers over de periode */
export interface NonNegativeDecimalPeriodValues {
    /** Value current period */
    valuePeriod1?: number;
    /** Value previous period */
    valuePeriod2?: number;

    [key: string]: any;
}

/** Aantal winstbewijzen en soortgelijke rechten */
export interface NonNegativeInteger {
    value?: number;

    [key: string]: any;
}

/** Omrekening van vreemde valuta */
export interface OmrekeningVreemdeValuta {
    omrekeningVreemdeValutaTekstueel?: OmrekeningVreemdeValutaTekstueel;

    [key: string]: any;
}

/** Grondslagen omrekening van vreemde valuta */
export interface OmrekeningVreemdeValutaTekstueel {
    foreignCurrencyTranslationPolicy?: FormattedExplanationPolicy;
    foreignCurrencyTranslationBalanceSheetPolicy?: FormattedExplanationPolicy;
    foreignCurrencyTranslationHyperinflationPolicy?: FormattedExplanationPolicy;
    foreignCurrencyTranslationIncomeStatementPolicy?: FormattedExplanationPolicy;
    foreignCurrencyTranslationActivitiesAbroadPolicy?: FormattedExplanationPolicy;
    foreignCurrencyTranslationActivitiesAbroadBalancePolicy?: FormattedExplanationPolicy;
    foreignCurrencyTranslationActivitiesAbroadProfitAndLossAccountPolicy?: FormattedExplanationPolicy;
    foreignCurrencyMethodConversionProcessingPolicy?: FormattedExplanationPolicy;
    foreignCurrencyTranslationActivitiesAbroadGoodwillAdjustmentActualValueBalancePolicy?: FormattedExplanationPolicy;
    foreignCurrencyTranslationActivitiesAbroadGoodwillAdjustmentActualValueProfitAndLossAccountPolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Onderhanden projecten */
export interface OnderhandenProjecten {
    constructionContractsAssets?: BalanceItem;
    onderhandenProjectenTekstueel?: OnderhandenProjectenTekstueel;
    onderhandenProjectenOverigeBedragenUitsplitsing?: OnderhandenProjectenOverigeBedragenUitsplitsing;

    [key: string]: any;
}

/** Uitsplitsing onderhanden projecten overige bedragen */
export interface OnderhandenProjectenOverigeBedragenUitsplitsing {
    constructionContractsAccumulatedProjectRevenues?: MonetaryNoDecimalsPeriodValues;
    constructionContractsProgressBillings?: MonetaryNoDecimalsPeriodValues;
    constructionContractsAmount?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Tekstuele toelichting onderhanden projecten */
export interface OnderhandenProjectenTekstueel {
    constructionContractsAssetsDisclosure?: FormattedExplanation;
    constructionContractsNoLegalOwnershipDescription?: FormattedExplanation;
    constructionContractsMethodsProjectIncome?: FormattedExplanation;
    constructionContractsMethod?: FormattedExplanation;

    [key: string]: any;
}

/** Ondertekening van de jaarrekening */
export interface OndertekeningJaarrekening {
  directorType?: Director;
  legalEntityNameManagingSupervisoryDirector?: String1000;
  signatureManagingSupervisoryDirectorsLocation?: String1000;
  signatureManagingSupervisoryDirectorsDate?: CustomDate;
  directorSignedStatus: YesNo;
  directorReasonNoSignature?: String1000;

  [key: string]: any;
}

/** Ondertekening van de jaarrekening natuurlijk persoon */
export interface OndertekeningJaarrekeningNatuurlijkPersoon {
  representativeType?: RepresentativeType;
  nameRepresentative?: String1000;
  signatureRepresentativeLocation?: String1000;
  signatureRepresentativeDate?: CustomDate;
  representativeSignedStatus: YesNo;
  representativeReasonNoSignature?: String1000;

  [key: string]: any;
}

/** Op aandelen gebaseerde betalingen */
export interface OpAandelenGebaseerdeBetalingen {
    opAandelenGebaseerdeBetalingenTekstueel?: OpAandelenGebaseerdeBetalingenTekstueel;

    [key: string]: any;
}

/** Op aandelen gebaseerde betalingen */
export interface OpAandelenGebaseerdeBetalingenAlgemeneGrondslagen {
    opAandelenGebaseerdeBetalingenAlgemeneGrondslagenTekstueel?: OpAandelenGebaseerdeBetalingenAlgemeneGrondslagenTekstueel;

    [key: string]: any;
}

/** Grondslagen op aandelen gebaseerde betalingen */
export interface OpAandelenGebaseerdeBetalingenAlgemeneGrondslagenTekstueel {
    shareBasedPaymentsPolicy?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Tekstuele toelichting op aandelen gebaseerde betalingen */
export interface OpAandelenGebaseerdeBetalingenTekstueel {
    shareBasedPaymentsDisclosure?: FormattedExplanation;
    shareBasedPaymentsImportantConditionsDescription?: FormattedExplanation;
    shareBasedPaymentsHedgingGrantedShareOptionsPolicyDescription?: FormattedExplanation;
    shareBasedPaymentsGrantedNotYetExercisedPositionDescription?: FormattedExplanation;
    shareBasedPaymentsTreasurySharesPaymentsAveragePrice?: MonetaryNoDecimalsPeriodValues;
    shareBasedPaymentsPurchaseCommitmentDescription?: FormattedExplanation;
    shareBasedPaymentsDeterminingFairValueIntrinsicValueShareOptionsDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Opbrengsten van andere effecten en vorderingen, die tot de vaste activa behoren */
export interface OpbrengstenAndereEffectenEnVorderingenVa {
    incomeReceivablesNoncurrentSecurities?: BalanceItem;
    opbrengstenAndereEffectenEnVorderingenVaTekstueel?: OpbrengstenAndereEffectenEnVorderingenVaTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting opbrengsten van andere effecten en vorderingen, die tot de vaste activa behoren */
export interface OpbrengstenAndereEffectenEnVorderingenVaTekstueel {
    incomeReceivablesNoncurrentSecuritiesDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Overige baten en lasten na belasting */
export interface OverigeBatenLastenNaBelasting {
    otherIncomeExpensesAfterTax?: BalanceItem;

    [key: string]: any;
}

/** Overige bedrijfskosten */
export interface OverigeBedrijfskosten {
    operatingExpensesOther?: MonetaryNoDecimalsPeriodValues;
    overigeBedrijfskostenUitsplitsing?: OverigeBedrijfskostenUitsplitsing;
    overigeBedrijfskostenTekstueel?: OverigeBedrijfskostenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting overige bedrijfskosten */
export interface OverigeBedrijfskostenTekstueel {
    operatingExpensesOtherDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie overige bedrijfskosten */
export interface OverigeBedrijfskostenUitsplitsing {
    personnelRelatedOtherExpenses?: BalanceItem;
    accommodationCosts?: BalanceItem;
    salesRelatedExpenses?: BalanceItem;
    carAndTransportCosts?: BalanceItem;
    officeRelatedExpenses?: BalanceItem;
    generalExpenses?: BalanceItem;
    operationalExpenses?: BalanceItem;
    undefinedOtherExpenses?: BalanceItem;

    [key: string]: any;
}

/** Overige bedrijfsopbrengsten */
export interface OverigeBedrijfsopbrengsten {
    operatingIncomeOther?: BalanceItem;

    [key: string]: any;
}

/** Overige fiscale reserves */
export interface OverigeFiscaleReserves {
    otherFiscalReserves?: BalanceItem;
    overigeFiscaleReservesTekstueel?: OverigeFiscaleReservesTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting overige fiscale reserves */
export interface OverigeFiscaleReservesTekstueel {
    otherFiscalReservesDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Overige gegevens */
export interface OverigeGegevens {
    informationOther?: FormattedExplanation;
    informationOtherLocationReference?: FormattedExplanation;
    auditorsOpinionStatementAbsence?: FormattedExplanation;
    auditorsOpinionReference?: FormattedExplanation;
    provisionsArticlesAssociationProfitAppropriation?: FormattedExplanation;
    provisionsArticlesAssociationContributionShortageCooperative?: FormattedExplanation;
    provisionsArticlesAssociationContributionShortageMutualGuaranteeCompany?: FormattedExplanation;
    provisionsArticlesAssociationSpecialGoverningControlStructureDisclosure?: FormattedExplanation;
    provisionsArticlesAssociationSpecialGoverningControlStructureNatureDescription?: FormattedExplanation;
    numberSharesEachHoldersHoldsASpecialStatutoryControlLegalPersonDescription?: FormattedExplanation;
    namesDirectorsOfACompanyAssociationCooperativeMutualtrustOrFoundationDescription?: FormattedExplanation;
    theNumberOfNonVotingSharesAndTheirPowersDescription?: FormattedExplanation;
    theNumberOfSharesWithoutProfitEntitlementAndTheirPowersDescription?: FormattedExplanation;
    branchOffices?: FormattedExplanation;

    [key: string]: any;
}

/** Overige toelichtingen */
export interface OverigeOverigeToelichtingen {
    overigeOverigeToelichtingenTekstueel?: OverigeOverigeToelichtingenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting overige toelichtingen */
export interface OverigeOverigeToelichtingenTekstueel {
    additionalInformationToArticle395aDisclosure?: FormattedExplanation;
    deviationsRegulationsBasedTrueAndFairViewDisclosure?: FormattedExplanation;
    changesGroupingBalanceSheetIncomeStatementStatement?: FormattedExplanation;
    profitCertificatesSimilarRightsDisclosure?: FormattedExplanation;
    powersProfitCertificatesSimilarRightsDescription?: FormattedExplanation;
    profitCertificatesSimilarRightsAmount?: NonNegativeInteger;

    [key: string]: any;
}

/** Overige reserves */
export interface OverigeReserves {
    reservesOther?: BalanceItem;
    overigeReservesTekstueel?: OverigeReservesTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting overige reserves */
export interface OverigeReservesTekstueel {
    reservesOtherDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Overige toelichtingen */
export interface OverigeToelichtingen {
    concessies?: Concessies;
    gemiddeldAantalWerknemers: GemiddeldAantalWerknemers;
    financieleInstrumenten?: FinancieleInstrumenten;
    opAandelenGebaseerdeBetalingen?: OpAandelenGebaseerdeBetalingen;
    bezoldigingBestuurdersCommissarissen?: BezoldigingBestuurdersCommissarissen;
    leningenBestuurdersCommissarissen?: LeningenBestuurdersCommissarissen;
    nogNietUitgeoefendeVerleendeRechten?: NogNietUitgeoefendeVerleendeRechten;
    gebeurtenissenNaBalansdatum?: GebeurtenissenNaBalansdatum;
    overigeOverigeToelichtingen?: OverigeOverigeToelichtingen;

    [key: string]: any;
}

/** Overige toelichtingen */
export interface OverigeToelichtingenWinstEnVerliesrekening {
    overigeToelichtingen?: OverigeToelichtingenWinstEnVerliesrekeningTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting overige toelichtingen */
export interface OverigeToelichtingenWinstEnVerliesrekeningTekstueel {
    otherNotesIncomeStatement?: FormattedExplanation;
    governmentSubsidiesDisclosure?: FormattedExplanation;
    governmentLeviesDisclosure?: FormattedExplanation;
    incomeExpensesChargedToOtherFinancialYearNatureAndExtentDescription?: FormattedExplanation;
    extentOfGovernmentSubsidiesDescription?: FormattedExplanation;
    natureOfGovernmentSubsidiesDescription?: FormattedExplanation;
    conditionalFinancialObligationsRelatingToDevelopmentFundsDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Overige vaste activa */
export interface OverigeVasteActiva {
    assetsNoncurrentOther?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Overige vlottende activa */
export interface OverigeVlottendeActiva {
    assetsCurrentOther?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Waardeveranderingen van immateriële en materiële vaste activa */
export interface OverigeWaardeveranderingenIvaMva {
    changesInValueIntangibleAssetsPropertyPlantEquipment?: MonetaryNoDecimalsPeriodValues;
    overigeWaardeveranderingenIvaMvaUitsplitsing?: OverigeWaardeveranderingenIvaMvaUitsplitsing;
    overigeWaardeveranderingenIvaMvaTekstueel?: OverigeWaardeveranderingenIvaMvaTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting waardeveranderingen van immateriële en materiële vaste activa */
export interface OverigeWaardeveranderingenIvaMvaTekstueel {
    changesInValueIntangibleAssetsPropertyPlantEquipmentDisclosure?: FormattedExplanation;
    impairmentIntangibleAssetsDisclosure?: FormattedExplanation;
    impairmentIntangibleAssetsReversalDisclosure?: FormattedExplanation;
    impairmentIntangibleAssetsIncomeStatementLineItems?: FormattedExplanation;
    impairmentIntangibleAssetsReversalIncomeStatementLineItems?: FormattedExplanation;
    impairmentPropertyPlantEquipmentDisclosure?: FormattedExplanation;
    impairmentPropertyPlantEquipmentReversalDisclosure?: FormattedExplanation;
    impairmentPropertyPlantEquipmentIncomeStatementLineItems?: FormattedExplanation;
    impairmentPropertyPlantEquipmentReversalIncomeStatementLineItems?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie waardeveranderingen van immateriële en materiële vaste activa */
export interface OverigeWaardeveranderingenIvaMvaUitsplitsing {
    impairmentIntangibleAssetsRecordedInIncomeStatement?: BalanceItem;
    impairmentIntangibleAssetsReversalRecordedInIncomeStatement?: BalanceItem;
    changesInValueIntangibleAssets?: MonetaryNoDecimalsPeriodValues;
    impairmentPropertyPlantEquipmentRecordedInIncomeStatement?: BalanceItem;
    impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatement?: BalanceItem;
    changesInValuePropertyPlantEquipment?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Totaal van passiva */
export interface PassivaJaarstukken {
    equityAndLiabilities?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Pensioenregelingen */
export interface Pensioenregelingen {
    pensioenregelingenTekstueel?: PensioenregelingenTekstueel;

    [key: string]: any;
}

/** Grondslagen pensioenregelingen */
export interface PensioenregelingenTekstueel {
    pensionArrangementsPolicy?: FormattedExplanationPolicy;
    retirementBenefitPlansBasedOnIAS19RDisclosure?: FormattedExplanationPolicy;
    retirementBenefitPlansBasedOnIAS19RCharacteristics?: FormattedExplanationPolicy;
    retirementBenefitPlansBasedOnIAS19RFundingArrangements?: FormattedExplanationPolicy;
    retirementBenefitPlansBasedOnIAS19RAssociatedRisks?: FormattedExplanationPolicy;
    retirementBenefitPlansBasedOnIAS19RImpactOnAmountsInFinancialStatements?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Percentage van de verkregen zeggenschap in het belang als gevolg van de fusie of overname */
export interface Percent {
    value?: number;

    [key: string]: any;
}

/** De van toepassing zijnde dekkingsgraad van de pensioenuitvoerder */
export interface PercentPeriodValues {
    /** Value current period */
    valuePeriod1?: number;
    /** Value previous period */
    valuePeriod2?: number;

    [key: string]: any;
}

/** Privé gebruik eigen bedrijf */
export interface PriveGebruikEigenBedrijf {
    privateUseOwnBusiness?: BalanceItem;

    [key: string]: any;
}

/** Balans voor of na resultaatbestemming */
export interface ProfitAppropriation {
    value?: ProfitAppropriationValue;

    [key: string]: any;
}

/** Publicatie WNT in de geconsolideerde en/of enkelvoudige jaarrekening danwel jaarrekening van een van de andere rechtspersonen binnen de groep */
export interface PublicationWNTfinancialStatement {
    value?: PublicationWNTfinancialStatementValue;

    [key: string]: any;
}

/** Aandeel in het geconsolideerde resultaat dat niet aan de rechtspersoon toekomt */
export interface ResultaatAandeelDerden {
    resultAttributableNoncontrollingInterest?: BalanceItem;
    resultaatAandeelDerdenTekstueel?: ResultaatAandeelDerdenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting aandeel in het geconsolideerde resultaat dat niet aan de rechtspersoon toekomt */
export interface ResultaatAandeelDerdenTekstueel {
    resultAttributableNoncontrollingInterestDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Resultaat na belastingen van het boekjaar */
export interface ResultaatBoekjaar {
    resultForTheYear?: BalanceItem;
    resultaatBoekjaarTekstueel?: ResultaatBoekjaarTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting resultaat van het boekjaar */
export interface ResultaatBoekjaarTekstueel {
    resultForTheYearDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Resultaat na belastingen */
export interface ResultaatNaBelastingen {
    resultAfterTax?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Resultaat voor belastingen */
export interface ResultaatVoorBelastingen {
    resultBeforeTax?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Resultaatbestemming */
export interface Resultaatbestemming {
    resultaatbestemmingTekstueel?: ResultaatbestemmingTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting resultaatbestemming */
export interface ResultaatbestemmingTekstueel {
    resultsAppropriationStatement?: FormattedExplanation;
    resultsAppropriationProposalStatement?: FormattedExplanation;
    duringTheFinancialYearDeclaredProposedDividendPerShareDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** SBI-code */
export interface Sbi {
    value?: string;

    [key: string]: any;
}

/** Schattingen, oordelen, veronderstellingen en onzekerheden */
export interface Schattingen {
    schattingenTekstueel?: SchattingenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting schattingen, oordelen, veronderstellingen en onzekerheden */
export interface SchattingenTekstueel {
    estimatesDisclosure?: FormattedExplanation;
    uncertaintyDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Schattingswijzigingen */
export interface Schattingswijzigingen {
    schattingswijzigingenTekstueel?: SchattingswijzigingenTekstueel;
    /** Specificatie van schattingswijzigingen */
    schattingswijzigingenSpecificatie?: SchattingswijzigingenSchattingswijziging[];

    [key: string]: any;
}

/** Specificatie van schattingswijzigingen */
export interface SchattingswijzigingenSchattingswijziging {
    changeAccountingEstimatesTypedMember: String255;
    changeAccountingEstimatesDescription?: FormattedExplanation;
    changeAccountingEstimatesEffectOnCurrentPeriodDescription?: FormattedExplanation;
    changeAccountingEstimatesEffectOnCurrentPeriodNoDeterminationQuantitiveEffectDescription?: FormattedExplanation;
    changeAccountingEstimatesEffectOnFuturePeriodsDescription?: FormattedExplanation;
    changeAccountingEstimatesEffectOnFuturePeriodsNoDeterminationStatisticalIndicationDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Grondslagen schattingswijzigingen */
export interface SchattingswijzigingenTekstueel {
    changeAccountingEstimatesExplanation?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Totaal van schulden */
export interface Schulden {
    liabilities?: MonetaryNoDecimalsPeriodValues;
    schuldenTekstueel?: SchuldenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting schulden */
export interface SchuldenTekstueel {
    liabilitiesDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Specificatie gemiddeld aantal werknemers naar segment */
export interface SegmentGemiddeldAantalWerknemers {
    segmentForAverageNumberEmployees: String255;
    averageNumberEmployees?: NonNegativeDecimalPeriodValues;

    [key: string]: any;
}

/** Som der kosten */
export interface SomDerKosten {
    sumOfExpenses?: MonetaryNoDecimalsPeriodValues;
    somDerKostenTekstueel?: SomDerKostenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting som der kosten */
export interface SomDerKostenTekstueel {
    sumOfExpensesDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Statutaire reserves */
export interface StatutaireReserves {
    statutoryReserves?: BalanceItem;
    statutaireReservesTekstueel?: StatutaireReservesTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting statutaire reserves */
export interface StatutaireReservesTekstueel {
    statutoryReservesDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Stelselwijzigingen */
export interface Stelselwijzigingen {
    stelselwijzigingenTekstueel?: StelselwijzigingenTekstueel;
    /** Specificatie van stelselwijzigingen */
    stelselwijzigingenSpecificatie?: StelselwijzigingenStelselwijziging[];

    [key: string]: any;
}

/** Specificatie van stelselwijzigingen */
export interface StelselwijzigingenStelselwijziging {
    changeAccountingPoliciesTypedMember: String255;
    changeAccountingPoliciesDescription?: FormattedExplanation;
    changeAccountingPoliciesMethodProcessingDescription?: FormattedExplanation;
    changeAccountingPoliciesEffectOnEquityAndResultsDescription?: FormattedExplanation;
    changeAccountingPoliciesEffectOnIndividualItemsDescription?: FormattedExplanation;
    changeAccountingPoliciesEffectOnFuturePeriodsDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Grondslagen stelselwijzigingen */
export interface StelselwijzigingenTekstueel {
    changeAccountingPoliciesDisclosure?: FormattedExplanationPolicy;
    reasonAdjustmentComparativesNotPossibleDescription?: FormattedExplanationPolicy;
    reasonNotPossibleToRecalculateMultiAnnualOverviewDescription?: FormattedExplanationPolicy;
    reasonReliableCalculationNotPossibleDescription?: FormattedExplanationPolicy;
    changeAccountingPoliciesNotPossibleToQuantifyDescription?: FormattedExplanationPolicy;
    numericalIndicationNotDetermined?: FormattedExplanationPolicy;

    [key: string]: any;
}

/** Voornamen */
export interface String1000 {
    value?: string;

    [key: string]: any;
}

/** Identificatienummer natuurlijk persoon / zakelijke partner */
export interface String255 {
    value?: string;

    [key: string]: any;
}

/** Huisnummertoevoeging */
export interface String4 {
    value?: string;

    [key: string]: any;
}

/** Vestigingsplaats NL */
export interface String80 {
    value?: string;

    [key: string]: any;
}

/** Toelichting op de jaarrekening */
export interface Toelichting {
    algemeneToelichting?: AlgemeneToelichting;
    algemeneGrondslagen?: AlgemeneGrondslagen;
    grondslagen?: Grondslagen;
    toelichtingBalans?: ToelichtingBalans;
    toelichtingWinstEnVerliesrekening?: ToelichtingWinstEnVerliesrekening;
    toelichtingKasstroomoverzicht?: ToelichtingKasstroomoverzicht;
    overigeToelichtingen: OverigeToelichtingen;

    [key: string]: any;
}

/** Toelichting op de balans */
export interface ToelichtingBalans {
    nietInBalansOpgenomenActivaVerplichtingen?: NietInBalansOpgenomenActivaVerplichtingen;
    resultaatbestemming?: Resultaatbestemming;
    vermeldingGeenOverlopendeActivaPassiva?: VermeldingGeenOverlopendeActivaPassiva;
    verschillenEnkelvoudigGeconsolideerd?: VerschillenEnkelvoudigGeconsolideerd;

    [key: string]: any;
}

/** Toelichting op het kasstroomoverzicht */
export interface ToelichtingKasstroomoverzicht {
    algemeen?: ToelichtingKasstroomoverzichtAlgemeen;

    [key: string]: any;
}

/** Algemene toelichtingen */
export interface ToelichtingKasstroomoverzichtAlgemeen {
    toelichtingKasstroomoverzichtAlgemeenTekstueel?: ToelichtingKasstroomoverzichtAlgemeenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting algemeen */
export interface ToelichtingKasstroomoverzichtAlgemeenTekstueel {
    cashFlowStatementDisclosure?: FormattedExplanation;
    cashFlowStatementExemptionDescription?: FormattedExplanation;
    compoundTransactionsAndOtherTransactionsWithoutTransferOfCashAndCashEquivalentsDisclosure?: FormattedExplanation;
    differencesBetweenCashFlowStatementMovementsAssetsEquityAndLiabilitiesDisclosure?: FormattedExplanation;
    compositionOfCashAndCashEquivalentsDisclosure?: FormattedExplanation;
    differencesBetweenBalanceSheetItemsMovementCashFlowStatementBeginningEndingBalancesDisclosure?: FormattedExplanation;
    exceptionalItemsCashFlowStatementDisclosure?: FormattedExplanation;
    cashAndCashEquivalentsAndTheCashFlowFromOperatingInvestingAndFinancingActivitiesAttributableToThirdPartiesDisclosure?: FormattedExplanation;
    reconcileOperatingResultCashFlowFromOperationsDirectMethodDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Toelichting op de winst-en-verliesrekening */
export interface ToelichtingWinstEnVerliesrekening {
    bijzonderePosten?: BijzonderePosten;
    transactiesVerbondenPartijen?: TransactiesVerbondenPartijen;
    overigeToelichtingenWinstEnVerliesrekening?: OverigeToelichtingenWinstEnVerliesrekening;

    [key: string]: any;
}

/** Totaal resultaat */
export interface TotaalResultaat {
    totalResult?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Transacties met verbonden partijen */
export interface TransactiesVerbondenPartijen {
    transactiesVerbondenPartijenTekstueel?: TransactiesVerbondenPartijenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting transacties met verbonden partijen */
export interface TransactiesVerbondenPartijenTekstueel {
    relatedPartyTransactionsStatement?: FormattedExplanation;

    [key: string]: any;
}

export interface TrialBalanceItem {
    /** RGS code */
    rgsCode?: string;
    /** Grootboeknummer */
    account?: string;
    /** Omschrijving */
    accountDescription: string;
    periodValues: MonetaryNoDecimalsPeriodValues;
    autogenerated?: boolean;

    [key: string]: any;
}

/** Vrijval uit herwaarderingsreserve */
export interface UitHerwaarderingsreserveVrijgevallenBedragen {
    revaluationReserveRelease?: BalanceItem;
    uitHerwaarderingsreserveVrijgevallenBedragenTekstueel?: UitHerwaarderingsreserveVrijgevallenBedragenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting vrijval uit herwaarderingsreserve */
export interface UitHerwaarderingsreserveVrijgevallenBedragenTekstueel {
    revaluationReserveReleaseDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uit te keren preferent dividend die in mindering wordt gebracht op het resultaat na belastingen */
export interface UitTeKerenPreferentDividend {
    preferredDividendDeductedFromResultForTheYear?: BalanceItem;
    uitTeKerenPreferentDividendTekstueel?: UitTeKerenPreferentDividendTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting uit te keren preferent dividend */
export interface UitTeKerenPreferentDividendTekstueel {
    preferredDividendDeductedFromResultForTheYearDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Totaal van vaste activa */
export interface VasteActiva {
    assetsNoncurrent?: MonetaryNoDecimalsPeriodValues;
    overigeVasteActiva?: OverigeVasteActiva;

    [key: string]: any;
}

/** Vastgoedbeleggingen */
export interface Vastgoedbeleggingen {
    investmentProperties?: MonetaryNoDecimalsPeriodValues;
    vastgoedbeleggingenUitsplitsing?: VastgoedbeleggingenUitsplitsing;
    vastgoedbeleggingenTekstueel?: VastgoedbeleggingenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting vastgoedbeleggingen */
export interface VastgoedbeleggingenTekstueel {
    investmentPropertiesDisclosure?: FormattedExplanation;
    investmentPropertiesFairValueDisclosure?: FormattedExplanation;
    investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescription?: FormattedExplanation;
    investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescription?: FormattedExplanation;
    investmentPropertiesImpairmentDescription?: FormattedExplanation;
    criteriaFinishedPhaseRealEstateInDevelopmentDescription?: FormattedExplanation;
    investmentPropertiesImpairmentReversalDescription?: FormattedExplanation;
    rentalIncomeFromInvestmentPropertiesDisclosure?: FormattedExplanation;
    directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosure?: FormattedExplanation;
    investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescription?: FormattedExplanation;
    investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescription?: FormattedExplanation;
    investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescription?: FormattedExplanation;
    investmentPropertiesMethodsAssumptionsToDetermineFairValueDescription?: FormattedExplanation;
    investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescription?: FormattedExplanation;
    investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescription?: FormattedExplanation;
    investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescription?: FormattedExplanation;
    investmentPropertiesInterestRateToDetermineFairValueDescription?: FormattedExplanation;
    investmentPropertiesInterestRateDeterminationConsiderationsDescription?: FormattedExplanation;
    investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescription?: FormattedExplanation;
    investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescription?: FormattedExplanation;
    investmentPropertiesDisposalsNotValuedAtFairValueDescription?: FormattedExplanation;
    investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescription?: FormattedExplanation;
    realEstateInExploitationDisclosure?: FormattedExplanation;
    realEstateInDevelopmentDisclosure?: FormattedExplanation;
    directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie vastgoedbeleggingen */
export interface VastgoedbeleggingenUitsplitsing {
    investmentPropertiesInExploitation?: BalanceItem;
    investmentPropertiesInDevelopment?: BalanceItem;

    [key: string]: any;
}

/** Vermelding dat er geen overlopende activa en passiva zijn opgenomen */
export interface VermeldingGeenOverlopendeActivaPassiva {
    vermeldingGeenOverlopendeActivaPassivaTekstueel?: VermeldingGeenOverlopendeActivaPassivaTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting vermelding dat er geen overlopende activa en passiva zijn opgenomen */
export interface VermeldingGeenOverlopendeActivaPassivaTekstueel {
    indicationNoAccruedAssetsLiabilitiesAreRecorded?: FormattedExplanation;

    [key: string]: any;
}

/** Verschillen in het eigen vermogen en het resultaat tussen de enkelvoudige en geconsolideerde jaarrekening */
export interface VerschillenEnkelvoudigGeconsolideerd {
    verschillenEnkelvoudigGeconsolideerdTekstueel?: VerschillenEnkelvoudigGeconsolideerdTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting verschillen in het eigen vermogen en het resultaat tussen de enkelvoudige en geconsolideerde jaarrekening */
export interface VerschillenEnkelvoudigGeconsolideerdTekstueel {
    differencesEquityResultSeparateConsolidatedFinancialStatementsDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Totaal van vlottende activa */
export interface VlottendeActiva {
    assetsCurrent?: MonetaryNoDecimalsPeriodValues;
    overigeVlottendeActiva?: OverigeVlottendeActiva;

    [key: string]: any;
}

/** Voorgestelde bedrag aan dividenduitkeringen aan houders van eigenvermogensinstrumenten (geclassificeerd als eigen vermogen) */
export interface VoorgesteldeBedragDividenduitkeringen {
    dividendPayableHoldersSharesRecordedAsEquity?: BalanceItem;
    voorgesteldeBedragDividenduitkeringenTekstueel?: VoorgesteldeBedragDividenduitkeringenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting voorgestelde bedrag aan dividenduitkeringen aan houders van eigenvermogensinstrumenten */
export interface VoorgesteldeBedragDividenduitkeringenTekstueel {
    dividendPayableHoldersSharesRecordedAsEquityDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Voorraden */
export interface Voorraden {
    inventories?: MonetaryNoDecimalsPeriodValues;
    voorradenUitsplitsing?: VoorradenUitsplitsing;
    voorradenTekstueel?: VoorradenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting voorraden */
export interface VoorradenTekstueel {
    inventoriesDisclosure?: FormattedExplanation;
    inventoryRawMaterialsConsumablesDisclosure?: FormattedExplanation;
    workInProgressDisclosure?: FormattedExplanation;
    inventoryFinishedTradeGoodsDisclosure?: FormattedExplanation;
    prepaymentsInventoriesDisclosure?: FormattedExplanation;
    inventoriesInterestCapitalisedDuringPeriodDescription?: FormattedExplanation;
    inventoriesNoLegalOwnershipDescription?: FormattedExplanation;
    inventoriesPledgedAsCollateralDescription?: FormattedExplanation;
    inventoriesPurchaseCommitmentsDescription?: FormattedExplanation;
    inventoriesCostMethodDescription?: FormattedExplanation;
    agriculturalInventoriesCurrentValueDisclosure?: FormattedExplanation;
    agriculturalInventoriesCurrentValueRevaluationsDisclosure?: FormattedExplanation;
    chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescription?: FormattedExplanation;
    inventoriesRealisableValueDescription?: FormattedExplanation;
    inventoriesWriteDownReversalCircumstancesDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie voorraden */
export interface VoorradenUitsplitsing {
    inventoryRawMaterialsConsumables?: BalanceItem;
    workInProgress?: BalanceItem;
    inventoryFinishedTradeGoods?: BalanceItem;
    prepaymentsInventories?: BalanceItem;

    [key: string]: any;
}

/** Voorzieningen */
export interface Voorzieningen {
    provisions?: MonetaryNoDecimalsPeriodValues;
    voorzieningenUitsplitsing?: VoorzieningenUitsplitsing;
    voorzieningenTekstueel?: VoorzieningenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting voorzieningen */
export interface VoorzieningenTekstueel {
    provisionsDisclosure?: FormattedExplanation;
    provisionRepairCostsDisclosure?: FormattedExplanation;
    provisionTaxLiabilitiesDisclosure?: FormattedExplanation;
    provisionEmployeeBenefitsDisclosure?: FormattedExplanation;
    provisionEnvironmentalDisclosure?: FormattedExplanation;
    provisionLegalProceedingsDisclosure?: FormattedExplanation;
    provisionMajorMaintenanceDisclosure?: FormattedExplanation;
    policyValuationCostsProcessedMajorMaintenanceProvisionDescription?: FormattedExplanation;
    natureCostsProcessedMajorMaintenanceProvisionDescription?: FormattedExplanation;
    mainAssumptionsProcessedMajorMaintenanceProvisionDescription?: FormattedExplanation;
    mainUncertainciesProcessedMajorMaintenanceProvisionDescription?: FormattedExplanation;
    transitionAccountingProvisionMajorMaintenanceDisclosure?: FormattedExplanation;
    provisionDisposalObligationDisclosure?: FormattedExplanation;
    provisionOnerousContractsDisclosure?: FormattedExplanation;
    provisionPensionObligationsDisclosure?: FormattedExplanation;
    natureOfProvisionDescription?: FormattedExplanation;
    mainCharactaristicsOfPensionArrangementsDescription?: FormattedExplanation;
    wayInWhichPensionArrangementsAreInsuredByPensionProviderDescription?: FormattedExplanation;
    applicableOrEstimatedFundingPositionOfPensionProviderDescription?: FormattedExplanation;
    applicableFundingPositionOfPensionProvider?: PercentPeriodValues;
    keyElementsRecoveryPlanPensionProviderDescription?: FormattedExplanation;
    provisionRestructuringDisclosure?: FormattedExplanation;
    provisionParticipatingInterestsDisclosure?: FormattedExplanation;
    provisionWarrantyDisclosure?: FormattedExplanation;
    characteristicsOfTheImplementingArrangementOrSimilarFinancingArrangementsDescription?: FormattedExplanation;
    provisionPensionObligationsDiscountRateDescription?: FormattedExplanation;
    provisionPensionObligationsSurvivalRateDescription?: FormattedExplanation;
    provisionPensionObligationsActuarialAssumptionsOtherDescription?: FormattedExplanation;
    pensionClaimEffectIncomeExpensesStatementDescription?: FormattedExplanation;
    provisionJubileeBenefitsDisclosure?: FormattedExplanation;
    deferredTaxLiabilitiesDisclosure?: FormattedExplanation;
    provisionInsuranceDisabilityRisksDisclosure?: FormattedExplanation;
    provisionDisabilityRisksDisclosure?: FormattedExplanation;
    provisionInsuranceIllnessDisabilityDisclosure?: FormattedExplanation;
    provisionShareBasedPaymentsDisclosure?: FormattedExplanation;
    provisionsOtherDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie voorzieningen */
export interface VoorzieningenUitsplitsing {
    provisionRepairCosts?: BalanceItem;
    provisionPensionObligations?: BalanceItem;
    provisionTaxLiabilities?: BalanceItem;
    provisionEmployeeBenefits?: BalanceItem;
    provisionEnvironmental?: BalanceItem;
    provisionLegalProceedings?: BalanceItem;
    provisionMajorMaintenance?: BalanceItem;
    provisionDisposalObligation?: BalanceItem;
    provisionOnerousContracts?: BalanceItem;
    provisionRestructuring?: BalanceItem;
    provisionParticipatingInterests?: BalanceItem;
    deferredTaxLiabilities?: BalanceItem;
    provisionWarranty?: BalanceItem;
    provisionJubileeBenefits?: BalanceItem;
    provisionInsuranceDisabilityRisks?: BalanceItem;
    provisionDisabilityRisks?: BalanceItem;
    provisionInsuranceIllnessDisability?: BalanceItem;
    provisionShareBasedPayments?: BalanceItem;
    provisionsOther?: BalanceItem;

    [key: string]: any;
}

/** Vorderingen */
export interface Vorderingen {
    receivables?: MonetaryNoDecimalsPeriodValues;
    vorderingenUitsplitsing?: VorderingenUitsplitsing;
    vorderingenHandelsdebiteurenUitsplitsing?: VorderingenHandelsdebiteurenUitsplitsing;
    vorderingenTekstueel?: VorderingenTekstueel;

    [key: string]: any;
}

/** Uitsplitsing handelsdebiteuren */
export interface VorderingenHandelsdebiteurenUitsplitsing {
    tradeReceivablesGross?: MonetaryNoDecimalsPeriodValues;
    tradeReceivablesProvisionBadDebts?: MonetaryNoDecimalsPeriodValues;
    tradeReceivablesNet?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Tekstuele toelichting vorderingen */
export interface VorderingenTekstueel {
    receivablesDisclosure?: FormattedExplanation;
    tradeReceivablesDisclosure?: FormattedExplanation;
    receivablesGroupCompaniesCurrentDisclosure?: FormattedExplanation;
    receivablesOtherAffiliatedCompaniesCurrentDisclosure?: FormattedExplanation;
    receivablesShareholdersParticipatingInterestsCurrentDisclosure?: FormattedExplanation;
    pensionReceivablesDisclosure?: FormattedExplanation;
    taxReceivablesDisclosure?: FormattedExplanation;
    receivablesIncomeTaxDisclosure?: FormattedExplanation;
    deferredTaxAssetsCurrentDisclosure?: FormattedExplanation;
    accruedIncomeDisclosure?: FormattedExplanation;
    receivablesNoLegalOwnershipDescription?: FormattedExplanation;
    receivablesMaturityExceedingOneYearDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie vorderingen */
export interface VorderingenUitsplitsing {
    tradeReceivables?: BalanceItem;
    receivablesGroupCompaniesCurrent?: BalanceItem;
    receivablesOtherAffiliatedCompaniesCurrent?: BalanceItem;
    receivablesShareholdersParticipatingInterestsCurrent?: BalanceItem;
    calledUpShareCapital?: BalanceItem;
    pensionReceivablesReceivablesOtherCurrent?: BalanceItem;
    receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrent?: BalanceItem;
    loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrent?: BalanceItem;
    loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrent?: BalanceItem;
    otherReceivablesOtherCurrent?: BalanceItem;
    receivablesOtherCurrent?: MonetaryNoDecimalsPeriodValues;
    taxReceivables?: BalanceItem;
    receivablesIncomeTax?: BalanceItem;
    deferredTaxAssetsCurrent?: BalanceItem;
    pensionReceivablesReceivablesAccruedIncome?: BalanceItem;
    accruedIncomeOther?: BalanceItem;
    accruedIncome?: MonetaryNoDecimalsPeriodValues;
    receivablesOtherCurrentSpecific?: MonetaryNoDecimalsPeriodValues;

    [key: string]: any;
}

/** Waardeveranderingen van agrarische voorraden */
export interface WaardeveranderingenAgrarischeVoorraden {
    changeValueAgriculturalStocks?: BalanceItem;

    [key: string]: any;
}

/** Gerealiseerde waardeveranderingen van beleggingen */
export interface WaardeveranderingenBeleggingenGerealiseerd {
    realisedChangesInValueOfInvestments?: MonetaryNoDecimalsPeriodValues;
    waardeveranderingenBeleggingenGerealiseerdUitsplitsing?: WaardeveranderingenBeleggingenGerealiseerdUitsplitsing;

    [key: string]: any;
}

/** Uitsplitsing en specificatie gerealiseerde waardeveranderingen van beleggingen */
export interface WaardeveranderingenBeleggingenGerealiseerdUitsplitsing {
    realisedChangesInValueOfInvestmentsInGroupCompanies?: BalanceItem;
    realisedChangesInValueOfInvestmentsInParticipatingInterestsOther?: BalanceItem;
    realisedChangesInValueOfInvestmentsInLandAndBuildings?: BalanceItem;
    realisedChangesInValueOfInvestmentsInInvestmentsOther?: BalanceItem;

    [key: string]: any;
}

/** Niet-gerealiseerde waardeveranderingen van beleggingen */
export interface WaardeveranderingenBeleggingenNietGerealiseerd {
    unrealisedChangesInValueOfInvestments?: MonetaryNoDecimalsPeriodValues;
    waardeveranderingenBeleggingenNietGerealiseerdUitsplitsing?: WaardeveranderingenBeleggingenNietGerealiseerdUitsplitsing;

    [key: string]: any;
}

/** Uitsplitsing  en specificatie niet-gerealiseerde waardeveranderingen van beleggingen */
export interface WaardeveranderingenBeleggingenNietGerealiseerdUitsplitsing {
    unrealisedChangesInValueOfInvestmentsInGroupCompanies?: BalanceItem;
    unrealisedChangesInValueOfInvestmentsInParticipatingInterestsOther?: BalanceItem;
    unrealisedChangesInValueOfInvestmentsInLandAndBuildings?: BalanceItem;
    unrealisedChangesInValueOfInvestmentsInOther?: BalanceItem;

    [key: string]: any;
}

/** Wijzigingen in de waarde van financiële vaste activa en van de effecten die tot de vlottende activa behoren */
export interface WaardeveranderingenFvaEnVanEffecten {
    changesValueFinancialAssetsSecurities?: MonetaryNoDecimalsPeriodValues;
    waardeveranderingenFvaEnVanEffectenUitsplitsing?: WaardeveranderingenFvaEnVanEffectenUitsplitsing;
    waardeveranderingenFvaEnVanEffectenTekstueel?: WaardeveranderingenFvaEnVanEffectenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting wijzigingen in de waarde van de financiële vaste activa en van de effecten die tot de vlottende activa behoren */
export interface WaardeveranderingenFvaEnVanEffectenTekstueel {
    changesValueFinancialAssetsSecuritiesDisclosure?: FormattedExplanation;
    impairmentSecuritiesDisclosure?: FormattedExplanation;
    impairmentSecuritiesReversalDisclosure?: FormattedExplanation;
    impairmentFinancialAssetsDisclosure?: FormattedExplanation;
    impairmentFinancialAssetsReversalDisclosure?: FormattedExplanation;
    impairmentFinancialAssetsReversalIncomeStatementLineItems?: FormattedExplanation;
    impairmentFinancialAssetsIncomeStatementLineItems?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie wijzigingen in de waarde van de financiële vaste activa en van de effecten die tot de vlottende activa behoren */
export interface WaardeveranderingenFvaEnVanEffectenUitsplitsing {
    impairmentSecuritiesRecordedInIncomeStatement?: BalanceItem;
    impairmentSecuritiesReversalRecordedInIncomeStatement?: BalanceItem;
    impairmentFinancialAssetsRecordedInIncomeStatement?: BalanceItem;
    impairmentFinancialAssetsReversalRecordedInIncomeStatement?: BalanceItem;

    [key: string]: any;
}

/** Wijziging in de reele waarde van vastgoedbeleggingen */
export interface WaardeveranderingenVastgoedbeleggingen {
    changesValueInvestmentProperties?: MonetaryNoDecimalsPeriodValues;
    waardeveranderingenVastgoedbeleggingenUitsplitsing?: WaardeveranderingenVastgoedbeleggingenUitsplitsing;
    waardeveranderingenVastgoedbeleggingenTekstueel?: WaardeveranderingenVastgoedbeleggingenTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting waardeveranderingen van vastgoedbeleggingen */
export interface WaardeveranderingenVastgoedbeleggingenTekstueel {
    changesValueInvestmentPropertiesDisclosure?: FormattedExplanation;
    impairmentInvestmentPropertiesDisclosure?: FormattedExplanation;
    impairmentInvestmentPropertiesReversalDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Uitsplitsing en specificatie wijziging in de reele waarde van vastgoedbeleggingen */
export interface WaardeveranderingenVastgoedbeleggingenUitsplitsing {
    impairmentInvestmentPropertiesRecordedInIncomeStatement?: BalanceItem;
    impairmentInvestmentPropertiesReversalRecordedInIncomeStatement?: BalanceItem;

    [key: string]: any;
}

/** Wijziging in voorraden gereed product en onderhanden werk */
export interface WaardeveranderingenVoorraad {
    changesInventoriesWorkInProgress?: BalanceItem;

    [key: string]: any;
}

/** Waardeverminderingen van vlottende activa */
export interface WaardeverminderingVlottendeActiva {
    impairmentCurrentAssets?: BalanceItem;
    waardeverminderingVlottendeActivaTekstueel?: WaardeverminderingVlottendeActivaTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting waardeverminderingen van vlottende activa */
export interface WaardeverminderingVlottendeActivaTekstueel {
    impairmentCurrentAssetsDisclosure?: FormattedExplanation;

    [key: string]: any;
}

/** Winst-en-verliesrekening */
export interface WinstEnVerliesrekening {
    /** Type indeling */
    winstEnVerliesrekeningIndelingType: WinstEnVerliesrekeningIndelingType;
    nettoOmzet?: NettoOmzet;
    waardeveranderingenAgrarischeVoorraden?: WaardeveranderingenAgrarischeVoorraden;
    waardeveranderingenVoorraad?: WaardeveranderingenVoorraad;
    geactiveerdeProductieEigenBedrijf?: GeactiveerdeProductieEigenBedrijf;
    priveGebruikEigenBedrijf?: PriveGebruikEigenBedrijf;
    exploitatiesubsidies?: Exploitatiesubsidies;
    overigeBedrijfsopbrengsten?: OverigeBedrijfsopbrengsten;
    bedrijfsopbrengsten?: Bedrijfsopbrengsten;
    brutoBedrijfsresultaat?: BrutoBedrijfsresultaat;
    kostenGrondEnHulpstoffen?: KostenGrondEnHulpstoffen;
    kostenUitbesteedWerk?: KostenUitbesteedWerk;
    lastenUitHoofdePersoneelsbeloningen?: LastenUitHoofdePersoneelsbeloningen;
    afschrijvingenIvaMva?: AfschrijvingenIvaMva;
    overigeWaardeveranderingenIvaMva?: OverigeWaardeveranderingenIvaMva;
    waardeveranderingenVastgoedbeleggingen?: WaardeveranderingenVastgoedbeleggingen;
    waardeveranderingenBeleggingenGerealiseerd?: WaardeveranderingenBeleggingenGerealiseerd;
    waardeveranderingenBeleggingenNietGerealiseerd?: WaardeveranderingenBeleggingenNietGerealiseerd;
    waardeverminderingVlottendeActiva?: WaardeverminderingVlottendeActiva;
    overigeBedrijfskosten?: OverigeBedrijfskosten;
    bedrijfslasten?: Bedrijfslasten;
    somDerKosten?: SomDerKosten;
    bedrijfsresultaat?: Bedrijfsresultaat;
    uitHerwaarderingsreserveVrijgevallenBedragen?: UitHerwaarderingsreserveVrijgevallenBedragen;
    financieleBatenLasten?: FinancieleBatenLasten;
    resultaatVoorBelastingen?: ResultaatVoorBelastingen;
    belastingen?: Belastingen;
    aandeelResultaatOndernemingenWaarinWordtDeelgenomen?: AandeelResultaatOndernemingenWaarinWordtDeelgenomen;
    totaalResultaat?: TotaalResultaat;
    overigeBatenLastenNaBelasting?: OverigeBatenLastenNaBelasting;
    resultaatNaBelastingen?: ResultaatNaBelastingen;
    resultaatAandeelDerden?: ResultaatAandeelDerden;
    nettoresultaatNaBelastingen?: NettoresultaatNaBelastingen;
    winstPerAandeel?: WinstPerAandeel;
    aandeelWinstPartners?: AandeelWinstPartners;
    nogTeVerdelenWinst?: NogTeVerdelenWinst;

    [key: string]: any;
}

/** Winst per aandeel */
export interface WinstPerAandeel {
    earningsPerShareBasic?: MonetaryNoDecimalsPeriodValues;
    earningsPerShareDiluted?: MonetaryNoDecimalsPeriodValues;
    winstPerAandeelTekstueel?: WinstPerAandeelTekstueel;

    [key: string]: any;
}

/** Tekstuele toelichting winst per aandeel */
export interface WinstPerAandeelTekstueel {
    earningsPerShareDisclosure?: FormattedExplanation;
    earningsPerShareReconciliationComponentsNetResultUsedAsBaseDisclosure?: FormattedExplanation;
    earningsPerShareConditionsOfFinancialInstrumentsThatResultInDilutionDescription?: FormattedExplanation;

    [key: string]: any;
}

/** Ondertekend door bestuurder of commissaris (J/N) */
export interface YesNo {
    value?: boolean;

    [key: string]: any;
}

/** Zakelijke partners */
export interface ZakelijkePartner {
    identificationNumberTypedMember: String255;
    prefix?: String1000;
    familyName: String1000;
    firstName?: String1000;
    dateOfBirth: CustomDate;
    ondertekeningJaarrekening?: OndertekeningJaarrekeningNatuurlijkPersoon;

    [key: string]: any;
}

export enum BasisOfPreparationValue {
    COMMERCIEEL = 'COMMERCIEEL',
    FISCAAL = 'FISCAAL',
}

export enum CashFlowStatementMethodValue {
    DIRECT = 'DIRECT',
    INDIRECT = 'INDIRECT',
    NIET_VAN_TOEPASSING = 'NIET_VAN_TOEPASSING',
}

export enum DirectorValue {
    BESTUURDER_HUIDIG = 'BESTUURDER_HUIDIG',
    BESTUURDER_VOORMALIG = 'BESTUURDER_VOORMALIG',
    COMMISSARIS_HUIDIG = 'COMMISSARIS_HUIDIG',
    COMMISSARIS_VOORMALIG = 'COMMISSARIS_VOORMALIG',
}

export enum FinancialStatementValue {
    ENKELVOUDIG = 'ENKELVOUDIG',
    GECONSOLIDEERD = 'GECONSOLIDEERD',
    GECONSOLIDEERD_EN_ENKELVOUDIG = 'GECONSOLIDEERD_EN_ENKELVOUDIG',
}

export enum IncomeStatementClassificationValue {
    FUNCTIONEEL = 'FUNCTIONEEL',
    CATEGORIAAL = 'CATEGORIAAL',
    NIET_VAN_TOEPASSING = 'NIET_VAN_TOEPASSING',
}

export enum JaarrekeningType {
    ENKELVOUDIG = 'ENKELVOUDIG',
    GECONSOLIDEERD = 'GECONSOLIDEERD',
}

export enum LegalFormValue {
    BV = 'BV',
    CV = 'CV',
    COOPERATIE = 'COOPERATIE',
    EENMANSZAAK = 'EENMANSZAAK',
    MAATSCHAP = 'MAATSCHAP',
    NV = 'NV',
    OWM = 'OWM',
    OV = 'OV',
    OVERIG = 'OVERIG',
    REDERIJ = 'REDERIJ',
    STICHTING = 'STICHTING',
    VOF = 'VOF',
    VERENIGING = 'VERENIGING',
}

export enum LegalSizeCriteriaValue {
   MICRO = "MICRO",
   KLEIN = "KLEIN",
   MIDDELGROOT = "MIDDELGROOT",
   GROOT = "GROOT",
}

export enum ProfitAppropriationValue {
    VOOR = 'VOOR',
    NA = 'NA',
}

export enum PublicationWNTfinancialStatementValue {
    ENKELVOUDIG = 'ENKELVOUDIG',
    GECONSOLIDEERD = 'GECONSOLIDEERD',
    GECONSOLIDEERD_EN_ENKELVOUDIG = 'GECONSOLIDEERD_EN_ENKELVOUDIG',
    IN_JAARREKENING_ANDERE_RECHTSPERSOON_BINNEN_GROEP = 'IN_JAARREKENING_ANDERE_RECHTSPERSOON_BINNEN_GROEP',
}

export enum RepresentativeTypeValue {
  VERANTWOORDELIJKE = 'VERANTWOORDELIJKE',
  GEVOLMACHTIGDE = 'GEVOLMACHTIGDE',
}

export enum WinstEnVerliesrekeningIndelingType {
    BRUTOBEDRIJFSRESULTAAT_KOSTEN = 'BRUTOBEDRIJFSRESULTAAT_KOSTEN',
    BEDRIJFSOPBRENGSTEN_BEDRIJFSLASTEN = 'BEDRIJFSOPBRENGSTEN_BEDRIJFSLASTEN',
}

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(
    message: string,
    status: number,
    response: string,
    headers: {
        [key: string]: any;
    },
    result?: any,
): Observable<any> {
    if (result !== null && result !== undefined) return _observableThrow(result);
    else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next('');
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = (event) => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
